(function(){
  /* ════════════════════════════════════════════════════════
     LYTEWORK HIS v3.0 — JAVASCRIPT
     - Calc engine math preserved from v2.8
     - Webhook payload shape unchanged
     - Email gate logic unchanged
     - Safety gate unchanged
     - localStorage keys unchanged: lw_profile, lw_profile_full
     - v3.40: (1) sun multiplier can no longer apply indoors from a stale
       value; (2) fluid replacement fraction exposed so the Calculations tab
       prints the fraction actually used; (3) cramping history no longer
       adjusts sweat [Na+] - evidence for a sodium/cramp link is weak, and
       the field is retained as context only; (4) population banding now runs
       on the underlying trait rather than the acclimation-adjusted value;
       (5) sodium presets and population bands recalibrated to WHOLE-BODY
       sweat [Na+] (Baker et al. 2016, J Sports Sci 34(4):358-368, n=506:
       35.9 +/- 10.4 mmol/L = ~825 +/- 239 mg/L) - the previous values were
       regional-patch magnitudes applied as whole-body; (6) measured sweat
       tests can now be entered as regional or whole-body, converted via
       Baker's published regression; (7) heat acclimation requires an
       explicit selection - it was defaulting to the third of four options
       and quietly reducing sodium by 18%; (8) decorrelation restored between
       a high sweat preset and high intensity; (9) declared gut tolerance now
       modulates the fluid absorption ceiling, not just carbohydrate.
     - NEW: renderProtocol/renderInventory/renderCalculations
       with adaptive Pre/In/Post logic + cadence rows
     - v3.39: physiology_weightDisplay payload field — "~70
       (estimated)" when weight absent, so the email profile row is
       never blank. Numeric field unchanged.
     - v3.38: results-page title branches on session type ("Session
       briefing." for training) — was hardcoded to race.
     - v3.37: saved-profile restore clamps custom sweat/sodium to
       current bounds (old saves could carry 3000 mg/L past the
       ceiling on every return visit).
     - v3.36: a drink covering >=95% of the target zeroes the capsule
       deficit — the coverage copy and the prescription now agree.
     - v3.35: live preview refactored to read calculate() directly —
       single source of truth, ends the preview-drift bug class.
     - v3.34: session capsule count derived from the unrounded hourly
       deficit, so a plan never delivers under the target it prints.
     - v3.33: transition-band cap now TAPERS into the full protocol
       (1 per 45 min at 75 min → uncapped at 150 min), removing the
       2h25→2h30 cliff.
     - v3.32: hard ceiling of 2500 mg/hr on the in-session sodium
       target (clamped, not merely advised), with a gate explaining
       the balance belongs in recovery.
     - v3.31: triathlon totals.sodium recomputed AFTER the per-leg
       capsule split, with swim excluded and run drink credited at
       RUN_INTAKE_FACTOR (was stale from the pre-split count).
     - v3.30: safety gates (concentration, dilutional, session load)
       judge ACTUAL in-session sodium intake rather than the target.
     - v3.29: gut-training note tests actual in-session sodium load
       rather than the target, and drops its carbohydrate advice when
       no carbohydrate is prescribed.
     - v3.28: per-hour sodium labelled as a TARGET on the summary
       strip (and in the email) so it can't be misread as intake
       when in-session capsules are zero or capped.
     - v3.27: sodium statement and drink note reconcile target vs
       actual intake when the transition-band cap is in force.
     - v3.26: totals.sodium now reports actual in-session INTAKE
       (drink + capsules) rather than target x hours, and the
       "remaining gap from capsules" row reports what capsules
       actually deliver. Recovery statement populated for the
       transition band.
     - v3.25: 75-150 min TRANSITION BAND — in-session capsules capped
       at ~1 per 45 min, balance moved to pre-load (race: reduced;
       training: light if hot) and a scaled recovery block. Closes the
       75-90 min race hole (was pre:none + post:none). Training 150 min+
       now gets a recovery block (was omitted until 240 min).
     - v3.24: races exit short mode at 75 min (the 75-90 min cool
       extension is training-only) — a race runs a normal in-session
       protocol rather than deferring all sodium to recovery.
     - v3.23: carb target rebuilt to duration×intensity evidence
       ladder (was duration tiers + flat intensity add-on, which
       over-fuelled 75-150 min efforts). Hard <75 min now gets a
       ~20 g oral-effect dose instead of 0.
     - v3.22: short-race heat bar tightened (>=25C, or >=22C+high
       humidity); short-mode sodium/carb/drink email statements
       explain the zero instead of stating targets as intake.
     - v3.21 SHORT-SESSION MODE: sessions < 75 min (or < 90 min
       without a heat stressor) zero in-session capsules by
       default and shift replacement to a recovery-primary
       post-session block. One conditional in-session capsule
       allowed for: short race in heat, raw sodium loss
       >= 2000 mg/hr, or frequent cramping history. Triathlon
       is EXCLUDED from short mode (leg-split logic governs).
       Payload adds session_shortMode + recovery_* fields.
  ════════════════════════════════════════════════════════ */
  var root = document.querySelector('.lw-his');
  if (!root) return;
  var ROOT_ID = root.id;
  var WEBHOOK = root.dataset.webhook || '';
  var PRODUCT_URL = root.dataset.productUrl || '/products/sodium-capsules';
  var CAPSULE_NA = parseInt(root.dataset.capsuleNa, 10) || 345;

  /* ─── PDP handoff (v3.42) ────────────────────────────────
     Builds the hp_* querystring the product page's "Your
     protocol" panel reads, and mirrors the same data to
     localStorage('lw_profile') so the panel persists on
     return visits without the params. */
  function lwDurFormat(min){
    min = min || 0;
    var h = Math.floor(min / 60), m = min % 60;
    if(h && m) return h + ' h ' + m + ' min';
    if(h) return h + ' h';
    return m + ' min';
  }
  function lwSessionLabel(){
    var mode = state.sessionType === 'race' ? 'Racing' : 'Training';
    var sport = state.sport ? state.sport.charAt(0).toUpperCase() + state.sport.slice(1) : '';
    return mode + (sport ? ' \u00b7 ' + sport : '') + ' \u00b7 ' + lwDurFormat(state.durationMin);
  }
  function lwHpData(r){
    var d = {
      target: String(r.sodiumPerHr != null ? r.sodiumPerHr : 0),
      caps: String(Math.ceil((r.totals && r.totals.capsules) || 0)),
      split: '',
      session: lwSessionLabel()
    };
    if(r.legSplit){
      d.split = 'Bike ' + r.legSplit.bike + ' \u00b7 Run ' + r.legSplit.run;
    }
    return d;
  }
  function lwHpUrl(r){
    var d = lwHpData(r);
    var q = 'hp_target=' + encodeURIComponent(d.target) +
            '&hp_caps=' + encodeURIComponent(d.caps) +
            '&hp_session=' + encodeURIComponent(d.session);
    if(d.split) q += '&hp_split=' + encodeURIComponent(d.split);
    return PRODUCT_URL + (PRODUCT_URL.indexOf('?') === -1 ? '?' : '&') + q;
  }
  function lwStoreProfile(r){
    try{ localStorage.setItem('lw_profile', JSON.stringify(lwHpData(r))); }catch(e){}
  }
  function lwRenderSeeCapsules(r){
    var a = $('#lwSeeCapsules');
    if(!a){
      var sum = $('#lwProtocolSummary');
      if(!sum || !sum.parentNode) return;
      a = document.createElement('a');
      a.id = 'lwSeeCapsules';
      a.className = 'lw-his__see-capsules';
      a.textContent = 'See capsules \u2192';
      sum.parentNode.insertBefore(a, sum.nextSibling);
    }
    a.href = lwHpUrl(r);
    a.onclick = function(){ lwStoreProfile(r); };
  }
  // Run-leg drink intake factor (v3.7): the same product delivers less sodium per hour
  // on the run (cups at aid stations) than on the bike (a full bottle). We credit the
  // run drink at this fraction of its bike-leg label rate. Conservative — lower = more
  // capsules = safer. Provisional pending sports-science (Greig) validation.
  var RUN_INTAKE_FACTOR = 0.65;

  /* ─── STATE ─────────────────────────────────────────── */
  var state = {
    step: 1,
    weight: null,
    weightUnit: 'kg',
    sex: null,
    ageBracket: null,
    experience: 'intermediate',
    gutSensitivity: 'moderate',
    heatAcclim: null,          // v3.40: must be chosen explicitly, no default
    tempC: 20,
    tempUnit: 'c',
    humidity: 'moderate',
    setting: 'outdoor',
    sun: 'shaded',
    sweatPreset: 'moderate',
    sweatRate: 1.0,
    sweatCustom: null,
    sodiumPreset: 'moderate',
    sodiumConc: 830,           // v3.40: whole-body equivalent (was 1000, a regional value)
    sodiumCustom: null,
    sodiumCustomMode: 'wholebody',
    crampFreq: 'never',
    sessionType: 'training',
    sport: 'cycle',
    triFormat: 'olympic',
    /* v3.41: triBaseSplit is the CANONICAL swim/bike/run shape for the selected
       format. triSwim/triBike/triRun are derived from it every calc via
       applyTriSplit() and are never the source of truth. Deriving from an
       immutable base makes the split idempotent — repeated rescales can no
       longer compound, and a half-written format can no longer be normalised
       against the old total (the v3.40 triathlon leg-split corruption). */
    triBaseSplit: { swim: 0.33, bike: 1.0, run: 0.67 },
    triSwim: 0.33,
    triBike: 1.0,
    triRun: 0.67,
    durationMin: 120,
    intensity: 'moderate',
    drinkSetup: 'water',
    drinkProduct: null,
    drinkProductRun: 'same',
    drinkSodiumMg: 0,
    aidStation: 'carry',
    email: null,
    emailUnlocked: false,
    results: null
  };

  /* ─── PRODUCT PRESETS ───────────────────────────────── */
  var PRODUCT_PRESETS = {
    maurten_160: { label: 'Maurten 160', sodium: 250 },
    tailwind: { label: 'Tailwind Endurance', sodium: 310 },
    skratch_sport: { label: 'Skratch Sport', sodium: 380 },
    maurten_320: { label: 'Maurten 320', sodium: 500 },
    skratch_high_sodium: { label: 'Skratch High Sodium', sodium: 800 },
    precision_ph1000: { label: 'Precision PH 1000', sodium: 1000 },
    lmnt: { label: 'LMNT', sodium: 1000 },
    precision_ph1500: { label: 'Precision PH 1500', sodium: 1500 },
    other_unsure: { label: 'Other / Not Sure', sodium: 300 }
  };

  /* ─── HELPERS ───────────────────────────────────────── */
  function $(sel, parent){ return (parent || root).querySelector(sel); }
  function $$(sel, parent){ return Array.prototype.slice.call((parent || root).querySelectorAll(sel)); }
  function set(key, val){ state[key] = val; updatePreview(); }
  /* Derive the three tri legs from the canonical base split scaled to the
     current duration. Pure function of (triBaseSplit, durationMin) — calling it
     twice gives the same answer as calling it once, which is exactly the
     property the old in-place rescale lacked. */
  function applyTriSplit(){
    var base = state.triBaseSplit;
    if(!base) return;
    var baseTotal = base.swim + base.bike + base.run;
    if(!(baseTotal > 0)) return;
    var k = ((state.durationMin || 0) / 60) / baseTotal;
    state.triSwim = base.swim * k;
    state.triBike = base.bike * k;
    state.triRun  = base.run  * k;
  }
  function fmt(n, d){ if(n==null||isNaN(n))return '—'; return Number(n).toFixed(d!=null?d:0); }
  function durStr(min){
    if(!min) return '—';
    var h = Math.floor(min/60), m = min%60;
    if(h===0) return m+'m';
    if(m===0) return h+'h';
    return h+'h '+(m<10?'0':'')+m+'m';
  }
  function durStrShort(min){
    if(!min) return '';
    var h = Math.floor(min/60), m = min%60;
    if(h===0) return m+'m';
    if(m===0) return h+'h';
    return h+'h '+m+'m';
  }
  /* Non-linear duration slider mapping (v3.4).
   Position scale 0–1000 maps to minutes via piecewise-linear segments so the
   anchors (30m / 2h / 4h / 8h / 17h) sit at 0/25/50/75/100% — fine resolution
   in the common 30m–4h range, compressed long-course tail. */
function durPosToMin(pos){
  pos = Math.max(0, Math.min(1000, pos));
  var m;
  if(pos <= 250)      m = 30  + (pos / 250) * 90;
  else if(pos <= 500) m = 120 + ((pos - 250) / 250) * 120;
  else if(pos <= 750) m = 240 + ((pos - 500) / 250) * 240;
  else                m = 480 + ((pos - 750) / 250) * 540;
  m = Math.round(m / 5) * 5;
  return Math.max(30, Math.min(1020, m));
}
function durMinToPos(min){
  min = Math.max(30, Math.min(1020, min));
  var pos;
  if(min <= 120)      pos = ((min - 30) / 90) * 250;
  else if(min <= 240) pos = 250 + ((min - 120) / 120) * 250;
  else if(min <= 480) pos = 500 + ((min - 240) / 240) * 250;
  else                pos = 750 + ((min - 480) / 540) * 250;
  return Math.round(Math.max(0, Math.min(1000, pos)));
}

  /* ─── CALC ENGINE (PRESERVED FROM v2.8) ─────────────── */
  function calcSweatRate(){
    if(state.sweatCustom && state.sweatCustom > 0) return state.sweatCustom;
    var base = state.sweatRate;
    // Missing weight → default to 70 kg (as getGutCap/getFluidCeiling already do) so
    // weight scaling neutralises to 1.0 but the environmental multipliers (temp,
    // humidity, sun, acclimation, intensity) STILL apply. The old early-return
    // discarded them, freezing sweat rate at the neutral baseline even in extreme heat.
    var weightKg = state.weight ? (state.weightUnit==='lbs' ? state.weight*0.453592 : state.weight) : 70;
    var weightMult = 1 + ((weightKg - 70) / 70) * 0.3;
    weightMult = Math.max(0.7, Math.min(1.4, weightMult));
    var tempMult = 1;
    if(state.tempC <= 10) tempMult = 0.75;
    else if(state.tempC <= 15) tempMult = 0.85;
    else if(state.tempC <= 20) tempMult = 0.95;
    else if(state.tempC <= 25) tempMult = 1.05;
    else if(state.tempC <= 30) tempMult = 1.20;
    else if(state.tempC <= 35) tempMult = 1.40;
    else if(state.tempC <= 40) tempMult = 1.60;
    else tempMult = 1.80;
    var humidMult = state.humidity==='low' ? 0.92 : (state.humidity==='high' ? 1.15 : 1.0);
    var settingMult = state.setting==='indoor' ? 1.08 : 1.0;
    // v3.40: the sun control is HIDDEN when the athlete selects indoor, but its
    // value was never reset - a stale "full sun" selection kept applying a 1.10
    // multiplier to an indoor session from a field the athlete could not see.
    var sunMult = state.setting==='indoor' ? 1.0
                : (state.sun==='full' ? 1.10 : (state.sun==='partial' ? 1.04 : 1.0));
    // v3.40: decorrelation. The "high sweat" preset is a BEHAVIOURAL descriptor
    // ("kit soaked, dripping") that already reflects the athlete's hard efforts.
    // Multiplying it by a high intensity multiplier counts the same physiology
    // twice. Softened when both fire and no measured sweat rate overrides them.
    var intensityMult = state.intensity==='low' ? 0.85 : (state.intensity==='high' ? 1.18 : 1.0);
    if(state.intensity==='high' && state.sweatPreset==='high' && !state.sweatCustom) intensityMult = 1.09;
    var ageMult = 1;
    if(state.ageBracket==='50plus') ageMult = 0.92;
    else if(state.ageBracket==='40to49') ageMult = 0.97;
    var sexMult = state.sex==='female' ? 0.90 : 1.0;
    var experienceMult = state.experience==='advanced' ? 1.08 : (state.experience==='beginner' ? 0.95 : 1.0);
    var heatAcclimMult = state.heatAcclim==='full' ? 1.10 : (state.heatAcclim==='partial' ? 1.05 : 1.0);
    var rate = base * weightMult * tempMult * humidMult * settingMult * sunMult * intensityMult * ageMult * sexMult * experienceMult * heatAcclimMult;
    var ceiling = state.setting==='indoor' ? 2.8 : 3.0;
    if(rate > ceiling) rate = ceiling;
    if(rate < 0.3) rate = 0.3;
    return Math.round(rate * 100) / 100;
  }
  // Replacement coefficient (v3.17) — the fraction of estimated sodium LOSS the
  // plan targets for replacement. Was a fixed 0.65; now flexes within the
  // literature's 0.50–0.80 self-selected range. Base 0.65 anchor, nudged up for
  // heat / high sweat-sodium / long duration, down for GI-limited / ultra where
  // drinking-to-thirst is partially protective. Clamped so it can never leave
  // the published envelope no matter how the flags stack. Applies to estimated
  // AND measured profiles — it governs how much of known loss to replace, a
  // separate question from how accurately loss is known.
  function getReplacementPct(){
    var pct = 0.65;
    var pop = classifySodiumPopulation(getBaselineSodiumConc());
    if(state.tempC >= 30) pct += 0.05;
    if(pop && (pop.band === 'high' || pop.band === 'very-high')) pct += 0.05;
    if(state.durationMin >= 180) pct += 0.05;
    if(state.gutSensitivity === 'sensitive') pct -= 0.05;
    if(state.durationMin >= 480) pct -= 0.05;
    if(pct < 0.50) pct = 0.50;
    if(pct > 0.80) pct = 0.80;
    return pct;
  }
  /* Regional patch -> whole-body sweat [Na+] (v3.40).
     Most commercial sweat tests report a REGIONAL (forearm patch) value, which
     runs systematically higher than whole-body. Baker et al. (2016) publish the
     regression y = 0.57x + 11.05 in mmol/L; converted to mg/L that is
     wholeBody = 0.57 * regional + 254. */
  function regionalToWholeBody(mgPerL){ return Math.round(0.57 * mgPerL + 254); }
  function effectiveSodiumCustom(){
    if(!state.sodiumCustom || state.sodiumCustom <= 0) return null;
    return state.sodiumCustomMode === 'regional'
      ? regionalToWholeBody(state.sodiumCustom)
      : state.sodiumCustom;
  }
  /* The athlete's underlying sweat [Na+] TRAIT, before condition adjustments.
     Population banding must run on this - previously it classified the
     acclimation-adjusted value, so a self-declared high-sodium, fully
     acclimated athlete was told their sweat sodium was "mid-range for
     athletes", conflating a modelled state with a trait. */
  function getBaselineSodiumConc(){
    var c = effectiveSodiumCustom();
    return c != null ? c : state.sodiumConc;
  }
  function calcSodiumConc(){
    var base = getBaselineSodiumConc();
    /* v3.40: cramping history NO LONGER adjusts sweat [Na+]. The evidence
       linking sodium to exercise-associated muscle cramping is weak and
       contested; neuromuscular fatigue is better supported. Our own white
       paper states we make no cramping claim, so a silent +10% here was
       inconsistent with it. The field is retained because it still governs
       the short-session single-capsule allowance, which is a practical
       concession rather than a physiological claim. */
    var acclimMult = state.heatAcclim==='full' ? 0.65 : (state.heatAcclim==='partial' ? 0.82 : (state.heatAcclim==='light' ? 0.95 : 1.08));
    return Math.round(base * acclimMult);
  }
  function getFluidCeiling(){
    // Gut absorption ceiling, scaled to body mass (~15 ml/kg/hr).
    // Fluid cannot be absorbed faster than this regardless of sweat rate.
    // v3.40: gastric emptying is one of the largest individual variables in
    // hydration and was modelled as a flat per-kg constant, while the athlete's
    // declared gut tolerance only affected carbohydrate. It now modulates fluid
    // too. The magnitudes are ours, not from a published source, and remain
    // unvalidated.
    var weightKg = state.weight ? (state.weightUnit==='lbs' ? state.weight*0.453592 : state.weight) : 70;
    var perKg = 15;
    if(state.gutSensitivity==='sensitive') perKg = 12.75;
    else if(state.gutSensitivity==='robust') perKg = 16.5;
    var ceiling = Math.round(weightKg * perKg);
    if(ceiling < 700) ceiling = 700;
    if(ceiling > 1500) ceiling = 1500;
    return ceiling;
  }
  /* v3.40: exposed as its own function so the Calculations tab can print the
     fraction ACTUALLY used. It previously hard-coded "~70% of sweat losses"
     beside the fluid figure regardless of whether 55%, 65% or 70% applied. */
  function getFluidReplacementPct(){
    var p;
    if(state.durationMin < 90)        p = 0.55;   // very short
    else if(state.durationMin < 180)  p = 0.70;   // <3h
    else if(state.durationMin < 360)  p = 0.65;   // 3-6h
    else if(state.durationMin < 600)  p = 0.65;   // 6-10h
    else                              p = 0.55;   // 10h+
    if(state.aidStation==='infrequent') p = Math.max(0.50, p - 0.10);
    return p;
  }
  function calcFluidTarget(sweatRate){
    // Replacement fraction by event duration (v3.18). Longer events target a
    // LOWER fraction of sweat losses — not because athletes deliberately taper,
    // but because the achievable/advisable replacement range drops as duration
    // grows (Oggi Zurzolo, on Ironman/ultra fluid-balance literature). Bands are
    // the midpoints of his recommended ranges: <3h 60–80, 3–6h 55–75, 6–10h
    // 60–70, 10h+ 45–65. A FLAT fraction across the event (no intra-session
    // ramp), since the progressive deficit is a practical artdefact, not a target.
    // NOTE: this replaces the old logic, which RAISED replacement to 0.75 on long
    // events — the wrong direction. Sub-90min keeps the lower 0.55 (short, near-
    // balance sessions don't need full replacement).
    var replacePct = getFluidReplacementPct();
    var target = sweatRate * replacePct * 1000;
    var ceiling = getFluidCeiling();
    if(target > ceiling) target = ceiling;
    return Math.round(target);
  }
  /* Absolute ceiling on the hourly sodium target (v3.32).
     Published in-session guidance tops out around 1,500 mg/hr, with documented
     salty sweaters in extreme heat justifying somewhat more. Beyond ~2,500 mg/hr
     there is no evidence base, absorption becomes the binding constraint rather
     than availability, and the arithmetic runs away — a maxed-out 17 h input was
     returning 7,900 mg/hr and 390 capsules. Clamp rather than advise: the
     unreplaced balance is a recovery and next-day problem, which is exactly what
     the rest of the model already says. */
  var SODIUM_HR_CEILING = 2500;
  function calcCapsules(sodiumPerHr, drinkSodium){
    var deficit = sodiumPerHr - drinkSodium;
    /* v3.36: a drink within 5% of the target IS coverage. The drinkCovers flag
       (>=95%) already drives "your drink covers the sodium target" copy, but a
       residual sliver — sometimes 20 mg/hr — was still ceiling up to a capsule,
       so the plan claimed coverage and prescribed a capsule in the same breath.
       A <=5% shortfall of a <=2500 target is physiological noise; zero it. */
    if(drinkSodium >= sodiumPerHr * 0.95) return { perHr: 0, deficit: 0 };
    if(deficit <= 0) return { perHr: 0, deficit: 0 };
    var perHr = deficit / CAPSULE_NA;
    return { perHr: Math.round(perHr * 10) / 10, deficit: Math.round(deficit) };
  }
  /* ─── Short-session mode (v3.21) ─────────────────────
     Sub-75-min sessions (sub-90 without a heat stressor) don't create an
     in-session sodium requirement: sweat is hypotonic, so plasma sodium
     HOLDS or rises across a short session even at high sweat rates. The
     deficit is real but total-body — it matters over the day, not the
     hour. Default: zero in-session capsules; replacement moves to a
     recovery-primary post block scaled to the actual loss estimate.
     Triathlon is excluded (leg-split logic governs; sprint tri revisit
     is a known follow-up, not a regression). */
  function hasHeatStressor(){
    return state.tempC >= 25 || state.humidity === 'high' || state.heatAcclim === 'none';
  }
  function isShortSession(){
    if(state.sport === 'triathlon') return false;
    if(state.durationMin < 75) return true;
    // 75-90 min cool extension applies to TRAINING only (v3.24). In a race you're
    // nearer the physiological ceiling and there's no reliable within-the-hour
    // recovery window — "take zero mid-race, replace it all after" is the weaker
    // call, so a 75 min+ race runs the standard in-session protocol.
    if(state.sessionType !== 'race' && state.durationMin < 90 && !hasHeatStressor()) return true;
    return false;
  }
  /* Conditional single in-session capsule. Returns { allow, reason } —
     the only sub-75-min in-session exceptions we defend: a short RACE in
     heat (no recovery window mid-event weekend), extreme raw sodium loss
     (>= 2000 mg/hr), or a frequent-cramping history (evidence mixed, cost
     of one capsule nil, that athlete population responds to it). */
  /* ─── Transition band (v3.25) ────────────────────────
     75–150 min sits between "the hour doesn't need it" and "in-session
     replacement is the protocol". Physiological need is real but modest,
     and it's the band where intensity is HIGHEST relative to duration —
     so intake capacity is lowest exactly where the old logic prescribed
     most. Racing doesn't change sweat physiology; it changes practicality
     (race-pace gut, aid-station dependence) and risk tolerance (start
     replete). So in this band the in-session rate is capped for
     practicality and the balance moves to pre-load and recovery, which is
     where it can actually be absorbed. Above 150 min the cap is dropped:
     need is genuinely high and relative intensity has fallen. */
  function isTransitionSession(){
    if(state.sport === 'triathlon') return false;
    if(isShortSession()) return false;
    return state.durationMin >= 75 && state.durationMin < 150;
  }
  /* Deficit + recovery dose. Shared by short mode and the transition band so
     one formula governs replacement everywhere: ~60% of total sodium loss net
     of whatever was taken in-session, clamped 1–4 capsules; fluid ≈ net
     deficit, clamped 500–1500 ml and rounded to 50. */
  function computeRecovery(sweatRate, sodiumConc, hours, fluidPerHr, inCaps){
    var lossFluidMl = Math.round(sweatRate * 1000 * hours);
    var lossSodiumMg = Math.round(sweatRate * sodiumConc * hours);
    var caps = Math.round((lossSodiumMg * 0.6) / CAPSULE_NA) - inCaps;
    if(caps < 1) caps = 1;
    if(caps > 4) caps = 4;
    var net = lossFluidMl - Math.round(fluidPerHr * hours);
    var fluidMl = Math.round(Math.min(1500, Math.max(500, net)) / 50) * 50;
    return { caps: caps, fluidMl: fluidMl, lossFluidMl: lossFluidMl, lossSodiumMg: lossSodiumMg };
  }
  function shortSessionAllowance(sweatRate, sodiumConc, capPerHr){
    if(capPerHr <= 0) return { allow: 0, reason: '' };
    var rawLoss = sweatRate * sodiumConc;
    // Race heat bar (v3.22): genuine heat only — >=25°C, or >=22°C with high
    // humidity. Deliberately TIGHTER than hasHeatStressor(), which still governs
    // pre-load phases: a 20°C humid morning is a sweaty ride, not a heat event,
    // and prescribing a capsule there undercuts the "we tell you when you don't
    // need it" positioning. Zero-acclimation alone no longer qualifies here.
    var genuineHeat = state.tempC >= 25 || (state.tempC >= 22 && state.humidity === 'high');
    if(state.sessionType === 'race' && genuineHeat)
      return { allow: 1, reason: 'short race in genuine heat — no recovery window mid-event' };
    if(rawLoss >= 2000)
      return { allow: 1, reason: 'very high sodium loss rate (' + Math.round(rawLoss) + ' mg/hr)' };
    if(state.crampFreq === 'frequently')
      return { allow: 1, reason: 'frequent cramping history' };
    return { allow: 0, reason: '' };
  }
  function getGutCap(){
    // Per-kg carb ceilings by training level, then adjusted for gut sensitivity.
    // Based on current sports-nutrition literature: beginners cap at ~0.9 g/kg/hr,
    // intermediate at ~1.3 g/kg/hr, advanced at ~1.6 g/kg/hr (gut-trained territory).
    // Carb absorption ceiling is set by intestinal transporter capacity (SGLT1 +
    // GLUT5), which is gut-trainable but NOT a function of body mass — a 90 kg
    // athlete doesn't absorb proportionally more carb than a 60 kg one. So the cap
    // is an ABSOLUTE g/hr by training/adaptation level, no longer scaled by weight
    // (v3.18). Values match the previous ~70 kg outputs, so a typical athlete is
    // unchanged; only very light / very heavy athletes shift, toward the shared
    // transporter ceiling. Gut sensitivity still modulates; elite unlock unchanged.
    var base;
    if(state.experience==='beginner') base = 60;
    else if(state.experience==='advanced') base = 110;
    else base = 90;                                       // intermediate
    
    // Gut sensitivity adjustment
    if(state.gutSensitivity==='sensitive') base *= 0.75;
    else if(state.gutSensitivity==='robust') base *= 1.15;
    
    // Absolute floor and ceiling
    var cap = Math.round(base);
    if(cap < 30) cap = 30;
    if(cap > 120) cap = 120;
    return cap;
  }
  function isEliteCarbCap(){
    // Gut-trained territory: advanced athlete, high intensity, long duration.
    // Unlocks the 120 g/hr ceiling per contemporary literature.
    return state.experience==='advanced' && state.intensity==='high' && state.durationMin>=180;
  }
  /* Carbohydrate target (v3.23) — rebuilt to the duration × intensity evidence
     ladder rather than duration tiers with a flat intensity add-on.

     The prior model jumped to 60 g/hr base the moment a session passed 75 min,
     then added +15 for intensity — producing ~75 g/hr for a hard 85-min effort,
     which is 2.5h+ ultra-endurance dosing applied to a session that doesn't need
     or absorb it. The ladder the literature actually supports:

       <45 min             : 0    — glycogen covers it, no ingestion needed
       45–75 min (hard)    : ~20  — central/oral + mouth-rinse effect; the benefit
                                     is neural, not fuelling, so keep it small
       45–75 min (easy/mod): 0    — no requirement
       75–150 min          : 30 → 45, climbing with intensity; genuine but modest
                                     fuelling, well below the transporter ceiling
       150–240 min         : 60   — established endurance fuelling
       240 min+            : 90   — glucose:fructose mixes to beat single-transporter
                                     absorption limits

     Intensity shifts WITHIN a band, it doesn't launch past it. A gut cap still
     applies on top. Short-mode zeroing (training, non-high intensity <75 min)
     happens downstream in calculate() and is unchanged. */
  function calcCarbTarget(){
    var d = state.durationMin, hi = state.intensity === 'high', lo = state.intensity === 'low';
    var base;
    if(d < 45){
      base = 0;                                    // no ingestion requirement
    } else if(d < 75){
      base = hi ? 20 : 0;                          // hard short: central/oral effect only
    } else if(d < 150){
      base = hi ? 45 : (lo ? 30 : 40);             // genuine but modest fuelling
    } else if(d < 240){
      base = hi ? 65 : (lo ? 50 : 60);
    } else {
      base = hi ? 90 : (lo ? 75 : 90);             // multi-transporter territory
    }
    if(state.sessionType === 'race' && base > 0) base += 10;
    var cap = isEliteCarbCap() ? Math.max(120, getGutCap()) : getGutCap();
    if(base > cap) base = cap;
    // Floor of 30 applies only once genuine fuelling has started (>=75 min).
    // Below that, 0 and the small oral-effect 20 must be allowed to stand.
    if(d >= 75 && base > 0 && base < 30) base = 30;
    return Math.round(base);
  }
  function calcTriBreakdown(fluidPerHr, sodiumPerHr, carbsPerHr, capsulesPerHr){
    var swim = state.triSwim, bike = state.triBike, run = state.triRun;
    return {
      swim: { duration: swim, fluid: 0, sodium: 0, carbs: 0, capsules: 0, note: 'No intake during swim' },
      bike: { duration: bike, fluid: Math.round(fluidPerHr*bike), sodium: Math.round(sodiumPerHr*bike), carbs: Math.round(carbsPerHr*bike), capsules: Math.round(capsulesPerHr*bike*10)/10 },
      run: { duration: run, fluid: Math.round(fluidPerHr*run*0.9), sodium: Math.round(sodiumPerHr*run), carbs: Math.round(carbsPerHr*run*0.95), capsules: Math.round(capsulesPerHr*run*10)/10 }
    };
  }
  function classifyConc(targetMgPerHr, fluidMl){
    if(!fluidMl || fluidMl <= 0) return 'na';
    var perL = (targetMgPerHr / fluidMl) * 1000;
    if(perL < 500) return 'dilute';
    if(perL < 1000) return 'typical';
    if(perL < 1500) return 'high';
    return 'very-high';
  }
  function classifySodiumPopulation(mgPerL){
    // Where this athlete's sweat sodium sits vs published athlete data.
    // Sources: Baker 2017 review + 2019 normative dataset. Athlete sweat [Na+]
    // spans ~10-90 mmol/L (~230-2070 mg/L), mean ~45 mmol/L (~1040 mg/L),
    // SD ~15 mmol/L (~345 mg/L). Cuts at roughly +/-1 SD (690 / 1380 mg/L) and
    // +2 SD (1840 mg/L). Runs on the EFFECTIVE value, so a measured sweat-test
    // result is classified identically to a profile estimate.
    // v3.40: rebuilt on WHOLE-BODY sweat [Na+]. The previous bands cited a
    // "Baker 2019 normative dataset" that does not exist, and their magnitudes
    // matched Baker's REGIONAL forearm values (43.6 +/- 18.2 mmol/L) while
    // being applied to what the tool calls whole-body sodium.
    // Source: Baker LB, Barnes KA, Anderson ML, Passe DH, Stofan JR. J Sports
    // Sci. 2016;34(4):358-368. n=506. Predicted whole-body sweat [Na+]
    // 35.9 +/- 10.4 mmol/L (~825 +/- 239 mg/L), range 18.2-70.8 (~418-1628).
    // Cuts at -1 SD (590), +1 SD (1065) and +2 SD (1305) mg/L.
    if(!mgPerL || mgPerL <= 0) return null;
    if(mgPerL < 590)  return { band:'low',       label:'lower than most athletes',       blurb:'on the lower end - you lose less sodium per litre of sweat than most athletes' };
    if(mgPerL < 1065) return { band:'mid',       label:'mid-range for athletes',         blurb:'in line with the bulk of endurance athletes' };
    if(mgPerL < 1305) return { band:'high',      label:'higher than most athletes',      blurb:'on the higher end - you lose more sodium per litre than most athletes' };
    return                    { band:'very-high', label:'much higher than most athletes', blurb:'among the saltiest sweaters - a measured sweat test is worth confirming' };
  }
  /* ─── Race-day forecast (DRAFT) — Open-Meteo, client-side ────────────────
     Renders only when section.settings.enable_race_forecast is ON. Uses the
     FREE keyless Open-Meteo endpoints (non-commercial / evaluation only). For
     public commercial use, move to a paid plan and proxy the API key so it is
     never exposed in client JS — then this code only needs its base URLs
     swapped. Maps race-day conditions into the calculator's existing tempC +
     humidity inputs; everything downstream is unchanged. */
  var LW_WX = {
    geo: 'https://geocoding-api.open-meteo.com/v1/search',
    forecast: 'https://api.open-meteo.com/v1/forecast',
    archive: 'https://archive-api.open-meteo.com/v1/archive',
    forecastDays: 16,
    climYears: 5
  };
  function lwWxHumidityBucket(rh){
    if(rh == null) return 'moderate';
    if(rh < 40) return 'low';
    if(rh > 70) return 'high';
    return 'moderate';
  }
  function lwWxGeocode(name){
    var url = LW_WX.geo + '?name=' + encodeURIComponent(name) + '&count=5&language=en&format=json';
    return fetch(url).then(function(res){ return res.json(); }).then(function(j){
      return (j && j.results) ? j.results : [];
    });
  }
  // Average temperature + humidity + cloud cover across the race window (startHour .. startHour+hoursNeeded)
  function lwWxWindowAvg(times, temps, hums, clouds, startHour, hoursNeeded){
    var tSum = 0, hSum = 0, cSum = 0, n = 0, cN = 0;
    for(var i = 0; i < times.length; i++){
      var hr = parseInt(times[i].substr(11, 2), 10);
      if(hr < startHour || hr >= startHour + hoursNeeded) continue;
      if(temps[i] == null) continue;
      tSum += temps[i];
      if(hums[i] != null) hSum += hums[i];
      if(clouds && clouds[i] != null){ cSum += clouds[i]; cN++; }
      n++;
    }
    return n ? { temp: tSum / n, rh: hSum / n, cloud: cN ? cSum / cN : null } : null;
  }
  function lwWxForecast(lat, lon, dateStr, startHour, hoursNeeded){
    var url = LW_WX.forecast + '?latitude=' + lat + '&longitude=' + lon +
      '&hourly=temperature_2m,relative_humidity_2m,cloud_cover&start_date=' + dateStr +
      '&end_date=' + dateStr + '&timezone=auto';
    return fetch(url).then(function(res){ return res.json(); }).then(function(j){
      if(!j || !j.hourly || !j.hourly.time) return null;
      var a = lwWxWindowAvg(j.hourly.time, j.hourly.temperature_2m, j.hourly.relative_humidity_2m, j.hourly.cloud_cover, startHour, hoursNeeded);
      return a ? { temp: a.temp, rh: a.rh, cloud: a.cloud, source: 'forecast' } : null;
    });
  }
  // "Typical" conditions: average the same calendar date across the last N years (ERA5 archive)
  function lwWxClimatology(lat, lon, raceDate, startHour, hoursNeeded){
    var mm = ('0' + (raceDate.getMonth() + 1)).slice(-2);
    var dd = ('0' + raceDate.getDate()).slice(-2);
    var thisYear = new Date().getFullYear();
    var calls = [];
    for(var y = thisYear - 1; y >= thisYear - LW_WX.climYears; y--){
      var ds = y + '-' + mm + '-' + dd;
      var url = LW_WX.archive + '?latitude=' + lat + '&longitude=' + lon +
        '&hourly=temperature_2m,relative_humidity_2m,cloud_cover&start_date=' + ds + '&end_date=' + ds + '&timezone=auto';
      calls.push(fetch(url).then(function(res){ return res.json(); }).catch(function(){ return null; }));
    }
    return Promise.all(calls).then(function(results){
      var tSum = 0, hSum = 0, cSum = 0, n = 0, cN = 0;
      for(var k = 0; k < results.length; k++){
        var j = results[k];
        if(!j || !j.hourly || !j.hourly.time) continue;
        var a = lwWxWindowAvg(j.hourly.time, j.hourly.temperature_2m, j.hourly.relative_humidity_2m, j.hourly.cloud_cover, startHour, hoursNeeded);
        if(a){ tSum += a.temp; hSum += a.rh; n++; if(a.cloud != null){ cSum += a.cloud; cN++; } }
      }
      return n ? { temp: tSum / n, rh: hSum / n, cloud: cN ? cSum / cN : null, source: 'typical' } : null;
    });
  }
  function lwWxGetConditions(lat, lon, dateStr, startHour, durationMin){
    var hoursNeeded = Math.max(1, Math.ceil((durationMin || 60) / 60));
    var raceDate = new Date(dateStr + 'T00:00:00');
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var daysOut = Math.round((raceDate - today) / 86400000);
    if(daysOut >= 0 && daysOut <= LW_WX.forecastDays){
      return lwWxForecast(lat, lon, dateStr, startHour, hoursNeeded).then(function(r){
        return r || lwWxClimatology(lat, lon, raceDate, startHour, hoursNeeded);
      });
    }
    return lwWxClimatology(lat, lon, raceDate, startHour, hoursNeeded);
  }
  // Cloud cover (%) -> sun exposure: clear sky = full sun, overcast = shaded
  function lwWxSunBucket(cloud){
    if(cloud == null) return null;
    if(cloud < 30) return 'full';
    if(cloud > 70) return 'shaded';
    return 'partial';
  }
  function lwWxApply(temp, rh, cloud){
    var tC = Math.round(temp);
    if(tC < 5) tC = 5;
    if(tC > 45) tC = 45;
    set('tempC', tC);
    var slider = $('#lwTemp'); if(slider) slider.value = tC;
    var disp = $('#lwTempDisplay'); if(disp) disp.textContent = state.tempUnit === 'f' ? Math.round(tC * 1.8 + 32) : tC;
    var bucket = lwWxHumidityBucket(rh);
    $$('#lwHumidity .lw-his__card-btn').forEach(function(x){ x.classList.remove('is-selected'); });
    var hb = $('#lwHumidity .lw-his__card-btn[data-value="' + bucket + '"]'); if(hb) hb.classList.add('is-selected');
    set('humidity', bucket);
    // Sun exposure — only when the session is outdoors (indoor hides this control)
    var sun = lwWxSunBucket(cloud);
    if(sun && state.setting === 'outdoor'){
      $$('#lwSun .lw-his__card-btn').forEach(function(x){ x.classList.remove('is-selected'); });
      var sb = $('#lwSun .lw-his__card-btn[data-value="' + sun + '"]'); if(sb) sb.classList.add('is-selected');
      set('sun', sun);
    }
  }

  function calcConfidence(){
    var score = 100;
    if(!state.weight) score -= 8;
    if(!state.sex) score -= 4;
    if(!state.ageBracket) score -= 3;
    if(!state.sweatCustom) score -= 5;
    if(!state.sodiumCustom) score -= 8;
    if(state.heatAcclim==='none' && state.tempC>=28) score -= 5;
    if(state.tempC>=35) score -= 4;
    if(state.durationMin>=600) score -= 4;
    return Math.max(60, score);
  }
  function buildAssumptions(){
    var a = [];
    if(!state.weight) a.push('Body weight estimated (~70kg)');
    if(!state.sweatCustom) a.push('Sweat rate based on profile + conditions');
    if(!state.sodiumCustom) a.push('Sodium concentration based on profile');
    if(state.sex==='prefer_not_to_say' || !state.sex) a.push('No biological-sex adjustment');
    return a;
  }
  function drinkSetupCarriesSodium(){
    return (state.drinkSetup==='picker' && state.drinkProduct) ||
           (state.drinkSetup==='custom' && state.drinkSodiumMg > 0);
  }
  /* ════════════════════════════════════════════════════════════
   MULTI-DIMENSIONAL GATING (v3.1)
   Gates fire on plan characteristics. Profile fields adapt copy.
   Each gate returns: { type, severity, label, body }
═══════════════════════════════════════════════════════════════ */

function getGates(r){
  var gates = [];

  // ─── GATE 1: Hourly concentration (preserved from v3.0 unsafeFlag) ───
  if(r.sodiumCapped) gates.push(buildSodiumCeilingGate(r));
  var naInSession = inSessionSodiumPerHr(r);
  if(naInSession > 1500 || (r.fluidPerHr > 0 && (naInSession / r.fluidPerHr) * 1000 > 1800)){
    gates.push(buildConcentrationGate(r));
  }

  // ─── GATES 2–4 (REMOVED v3.16): session-load fluid / sodium / capsule gates ───
  // These fired on cumulative session TOTALS, which scale with duration — so any
  // long-course event tripped them regardless of how normal the per-hour rates were.
  // Replaced by the rate/physiology gates already here (concentration, dilutional)
  // plus a soft, non-blocking sodium-loss validation note (buildSodiumValidationNote).
  // Builder functions left below but no longer called.

  // ─── GATE 5: Duration + experience ───
  if(state.durationMin >= 360 && state.experience === 'beginner'){
    gates.push(buildDurationExperienceGate(r));
  }

  // ─── GATE 6: Dilutional risk — high fluid + low sodium concentration ───
  // The classic hyponatremia setup: lots of fluid carrying very little sodium.
  // Fires only when total fluid is high, concentration is dilute, and the
  // session is long enough for plasma sodium to actually drift.
  // Dilutional risk is high fluid INTAKE RATE paired with very dilute sodium — not a
  // high cumulative total (which any long event hits). Rate-based so a long, modest-
  // intake plan like a low-sweat athlete drinking below their losses never trips it.
  var concPerL = r.fluidPerHr > 0 ? (inSessionSodiumPerHr(r) / r.fluidPerHr) * 1000 : 0;
  if(r.fluidPerHr >= 750 && concPerL > 0 && concPerL < 300 && state.durationMin >= 180){
    gates.push(buildDilutionalGate(r, Math.round(concPerL)));
  }

  return gates;
}

/* Soft sodium-loss validation note (v3.16) — NON-BLOCKING.
   Fires when estimated sweat sodium LOSS is high enough that a measured sweat
   test would materially change the plan. It's a confidence prompt, not a safety
   stop: never goes through getGates()/renderUnsafeInterrupt, never blocks results.
   Suppressed when the concentration hard-gate already fired (don't say "get a
   sweat test" twice) and when the athlete already entered measured data. */
function buildSodiumValidationNote(r){
  if(state.sodiumCustom && state.sodiumCustom > 0) return null;
  var lossPerHr = Math.round(r.sweatRate * r.sodiumConc);
  if(lossPerHr <= 1500) return null;
  var concGateFired = r.gates && r.gates.some(function(g){ return g.type === 'concentration'; });
  if(concGateFired) return null;
  return {
    lossPerHr: lossPerHr,
    body: 'Your estimated sweat sodium loss is high (' + lossPerHr + ' mg/hr), and it\'s based on your profile rather than a measurement. ' +
          'At this loss rate a sweat test would materially sharpen the plan — your true sodium need could sit meaningfully above or below the estimate. ' +
          'The plan below is built to be safe in the meantime; treat the sodium figures as a strong starting point and confirm with a test before a key session.'
  };
}

/* Soft fluid-ceiling note (v3.19) — NON-BLOCKING.
   Fires on long efforts where fluid intake can't keep pace with losses: any
   event >= 6h (regardless of sweat rate), plus >= 3h efforts at a high sweat
   rate (>= 1.8 L/hr). Deliberately NOT based on a projected body-mass-loss %,
   which is an unreliable extrapolation at these durations. Its job is to frame
   the tapered fluid figure as a practical CEILING, not a pre-race target —
   carrying an honest, sodium-forward "drink to thirst" message rather than a
   number to chase. Never blocks results. */
function buildFluidCeilingNote(r){
  if(state.durationMin < 180) return null;
  if(state.durationMin < 360 && r.sweatRate < 1.8) return null;
  return {
    sweatRate: r.sweatRate,
    body: 'On an effort this long, your gut can\'t absorb fluid as fast as you lose it — ' +
          'so the fluid figure above is a practical ceiling, not a target to chase. ' +
          'A fluid deficit by the finish is normal and expected; reading the number as a goal to hit ' +
          'only pushes you to over-drink and risk an unsettled stomach. Drink to thirst, ' +
          'manage pace and cooling, and for a key session a sweat test and a coach\'s input are worth more ' +
          'here than any single fluid target. The one number to hold steady isn\'t fluid — it\'s your sodium.'
  };
}

/* In-session sodium ACTUALLY ingested, mg/hr (v3.30).
   Safety gates must judge the plan the athlete will execute, not the target
   used to size the deficit. Once short mode zeroes capsules and the
   transition band caps them, target and intake diverge sharply — a plan
   whose only in-session sodium is 380 mg/hr of sports drink was being
   flagged as a 2000 mg/L concentration risk it never creates. */
function inSessionSodiumPerHr(r){
  if(!r) return 0;
  if(r.shortMode || r.transitionMode) return (r.drinkSodium || 0) + (r.sodiumDeficit || 0);
  return r.sodiumPerHr != null ? r.sodiumPerHr : 0;
}
/* Concentration gate (the original v3.0 advisory) */
/* Concentration gate (v3.2 — branched copy) */
function buildConcentrationGate(r){
  var naHr = inSessionSodiumPerHr(r);
  var concPerL = r.fluidPerHr > 0 ? Math.round((naHr / r.fluidPerHr) * 1000) : 0;
  var hourlyExceeds = naHr > 1500;
  var concExceeds = concPerL > 1800;

  var body;
  if(hourlyExceeds && concExceeds){
    body = 'Your hourly sodium intake of ' + naHr + ' mg/hr at ' + concPerL +
           ' mg/L sits above the range we treat as typical on both axes (1,000–1,500 mg/hr at 500–1,800 mg/L — our own advisory figures, not a published standard). ' +
           'This can be correct for documented salty sweaters in extreme heat — but worth validating with a sweat test before relying on it.';
  } else if(hourlyExceeds){
    body = 'Your hourly sodium intake of ' + naHr + ' mg/hr sits above the range we treat as typical (1,000–1,500 mg/hr — our own advisory figure, not a published standard). ' +
           'This can be correct for documented salty sweaters in extreme heat — but worth validating with a sweat test before relying on it.';
  } else {
    body = 'Your sodium concentration of ' + concPerL + ' mg/L sits above the range we treat as typical (500–1,800 mg/L — our own advisory figure, not a published standard) — ' +
           'while your hourly intake of ' + naHr + ' mg/hr is within normal range, the concentration of that intake is high. ' +
           'This can be correct for documented salty sweaters in extreme heat — but worth validating with a sweat test before relying on it.';
  }

  return {
    type: 'concentration',
    severity: 'warning',
    label: 'High sodium concentration',
    body: body
  };
}

/* Session-load fluid gate */
function buildFluidLoadGate(r){
  var totalL = (r.totals.fluid / 1000).toFixed(1);
  var gut = state.gutSensitivity;
  var body = 'This plan calls for ' + totalL + ' L of fluid across the session. ';
  if(gut === 'robust'){
    body += 'Your gut profile suggests you can absorb the per-hour rate, but the absolute volume still requires gut training at this intake level. ' +
            'Practice a half-length version in training before relying on it for a key session.';
  } else if(gut === 'sensitive'){
    body += 'Your gut profile suggests caution at this volume. Consider scaling back to the lower end of the per-hour replacement range, ' +
            'or building tolerance with shorter sessions first.';
  } else {
    body += 'This is a high absolute volume that benefits from gut training. ' +
            'Practice a half-length version in training before relying on it for a key session.';
  }
  return {
    type: 'session_load_fluid',
    severity: 'advisory',
    label: 'High fluid volume',
    body: body
  };
}

/* Ceiling gate (v3.32) — fires when the modelled target was clamped. */
function buildSodiumCeilingGate(r){
  return {
    type: 'sodium_ceiling',
    severity: 'advisory',
    label: 'Sodium target capped',
    body: 'Your modelled losses imply a replacement target of ' + r.sodiumUncapped + ' mg/hr. ' +
          'We cap in-session sodium at ' + r.sodiumPerHr + ' mg/hr because there is no evidence base above that, ' +
          'and past it absorption — not availability — is the limit: more capsules would sit in your gut rather than reach your blood. ' +
          'The balance is not lost, it is a recovery and next-day problem. Replace it with fluid and salt after the session, ' +
          'and get a sweat sodium test before planning around numbers this high.'
  };
}
/* Session-load sodium gate */
function buildSodiumLoadGate(r){
  var totalG = (r.totals.sodium / 1000).toFixed(1);
  return {
    type: 'session_load_sodium',
    severity: 'advisory',
    label: 'High total sodium load',
    body: 'This plan calls for ' + r.totals.sodium + ' mg (' + totalG + ' g) of sodium across the session. ' +
          'This is appropriate for documented high-sweat, high-loss athletes in extreme conditions — but is well above what most athletes need. ' +
          'Cross-check against your race history: have you needed sodium intake at this scale before? If unsure, validate with a sweat sodium test before relying on it.'
  };
}

/* Session-load capsules / cadence gate */
function buildCapsuleCadenceGate(r){
  var totalCaps = Math.ceil(r.totals.capsules);
  var intervalMin = r.capsulesPerHr > 0 ? Math.round(60 / r.capsulesPerHr) : 0;
  var body = 'This plan requires ' + totalCaps + ' capsules across the session, ' +
             'roughly one every ' + intervalMin + ' minutes. ';
  if(state.experience === 'beginner'){
    body += 'Sustained capsule cadence over a long session takes practice. ' +
            'The protocol below paces these for you — set timer reminders, and consider running a half-length version in training first.';
  } else {
    body += 'The protocol below paces these for you. Set timer reminders if you tend to lose track of intake during high-effort segments.';
  }
  return {
    type: 'session_load_capsules',
    severity: 'advisory',
    label: 'High-cadence plan',
    body: body
  };
}

/* Duration + experience gate */
function buildDurationExperienceGate(r){
  return {
    type: 'duration_experience',
    severity: 'advisory',
    label: 'Long session for current experience level',
    body: 'Sessions of this length (' + durStr(state.durationMin) + ') carry execution risk for less experienced athletes — ' +
          'not because the plan is wrong, but because sustained fuelling and hydration discipline is a learned skill. ' +
          'Consider running a half-length version of this plan in training before relying on it for a race, ' +
          'and working with a coach or sports-medicine professional for key sessions at this distance.'
  };
}

/* Dilutional-risk gate — high fluid, low sodium concentration */
function buildDilutionalGate(r, concPerL){
  var totalL = (r.totals.fluid / 1000).toFixed(1);
  return {
    type: 'dilutional_risk',
    severity: 'warning',
    label: 'Low sodium relative to fluid',
    body: 'This plan pairs a high fluid volume (' + totalL + ' L) with a low sodium concentration (' + concPerL +
          ' mg/L). Over a long session, taking in large amounts of fluid with little sodium is the main driver of low blood sodium (hyponatremia), which is dangerous. ' +
          'If your sodium losses really are this low this can be fine — but if in doubt, drink to thirst rather than to a fixed volume, and consider whether your sodium profile is set too low. Validate with a sweat test before relying on this for a key session.'
  };
}

/* Build run-leg sodium gap advisory (v3.2) */
function buildRunSodiumGapNote(r){
  // Only fires for triathlon long-course with high-sodium-drink coverage on the bike
  if(state.sport !== 'triathlon') return null;
  if(state.triFormat !== 'half' && state.triFormat !== 'full') return null;
  if(state.drinkSetup === 'water') return null;
  if(!r.drinkSodium || r.drinkSodium < r.sodiumPerHr * 0.85) return null;

  // Run-leg sodium need. The run carries its FULL sodium as capsules (the bike drink
  // isn't on the run course), so this is the plan figure that flows into the timeline
  // and inventory — not a per-hour deficit. A spare is advised in copy, not baked into
  // the count, so the displayed plan stays honest.
  var runHours = state.triRun;
  var runSodiumNeed = Math.round(r.sodiumPerHr * runHours);
  // Credit the run drink (discounted for cup-vs-bottle intake); capsules cover the gap.
  var runCreditPerHr = r.runDrinkCreditPerHr || 0;
  var runCredit = Math.round(runCreditPerHr * runHours);
  var runGap = Math.max(0, runSodiumNeed - runCredit);
  var capsulesToCarry = Math.max(1, Math.ceil(runGap / CAPSULE_NA));

  return {
    type: 'run_sodium_gap',
    runHours: runHours,
    runSodiumNeed: runSodiumNeed,
    runDrinkLabel: r.runDrinkLabel || null,
    runDrinkSodium: r.runDrinkSodium || 0,
    runCreditPerHr: runCreditPerHr,
    runCredit: runCredit,
    runGap: runGap,
    capsulesToCarry: capsulesToCarry,
    capsuleWord: capsulesToCarry === 1 ? 'capsule' : 'capsules',
    drinkLabel: r.drinkLabel || 'your bike drink'
  };
}

/* Build pre-rendered HTML for run-leg sodium note (CADENCE-style) */
function buildRunSodiumNoteEmailHtml(note){
  if(!note) return '';
  var runMinLabel = durStrShort(Math.round(note.runHours * 60));
  var prose;
  var leadLabel = note.drinkLabel.replace(/^your\s+/i, '');
  if(note.runDrinkLabel){
    if(note.runGap > 0){
      prose = 'Your ' + leadLabel + ' covers your bike-leg sodium — but the run is different. ' +
              'On the run you\'ll be on ' + note.runDrinkLabel + ', and you drink less from cups than from a bottle, so we count it at ~65% (' + note.runCreditPerHr + ' mg/hr). ' +
              'That leaves a gap — carry ' + note.capsulesToCarry + ' ' + note.capsuleWord + ' in a run-leg flask or race-belt pocket to top it up across the ' + runMinLabel + ' run. ' +
              'Confirm your race actually carries ' + note.runDrinkLabel + '; if not, carry more. Pack a spare in case you drop one.';
    } else {
      prose = 'Your ' + leadLabel + ' covers your bike-leg sodium, and on the run you\'ll be on ' + note.runDrinkLabel + ' — even counted at ~65% for cup intake (' + note.runCreditPerHr + ' mg/hr) it covers the run target on its own. ' +
              'Carry ' + note.capsulesToCarry + ' ' + note.capsuleWord + ' as backup across the ' + runMinLabel + ' run, in case the race doesn\'t carry it or you drink less than planned. Confirm what your race actually serves.';
    }
  } else {
    prose = 'Your ' + leadLabel + ' covers your bike-leg sodium target — but the run is different. ' +
            'Aid stations carry water and gels, not your bike drink, so your sodium supply line drops to zero the moment you rack the bike. ' +
            'Carry ' + note.capsulesToCarry + ' ' + note.capsuleWord + ' in a run-leg flask or race-belt pocket — that\'s your sodium plan for the ' +
            runMinLabel + ' run. Pack a spare in case you drop one.';
  }

  var html = '';
  html += '<tr><td style="padding:48px 40px 0;">';
  html += '<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">';
  html += '<tr><td style="border-left:2px solid #9CF9DA;padding:4px 0 4px 20px;">';
  html += '<div style="font-family:\'IBM Plex Mono\',Courier New,monospace;font-size:10px;font-weight:600;letter-spacing:0.22em;color:#140049;margin-bottom:10px;">RUN LEG — SODIUM CARRY</div>';
  html += '<p style="font-size:15px;line-height:1.65;color:#0B0626;margin:0;">' + prose + '</p>';
  html += '</td></tr>';
  html += '</table>';
  html += '</td></tr>';
  return html;
}

/* Build pre-rendered HTML for fluid-ceiling note (CADENCE-style, mint border) */
function buildFluidCeilingNoteEmailHtml(note){
  if(!note) return '';
  var html = '';
  html += '<tr><td style="padding:48px 40px 0;">';
  html += '<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">';
  html += '<tr><td style="border-left:2px solid #9CF9DA;padding:4px 0 4px 20px;">';
  html += '<div style="font-family:\'IBM Plex Mono\',Courier New,monospace;font-size:10px;font-weight:600;letter-spacing:0.22em;color:#140049;margin-bottom:10px;">FLUID &amp; THE LONG DAY</div>';
  html += '<p style="font-size:15px;line-height:1.65;color:#0B0626;margin:0;">' + note.body + '</p>';
  html += '</td></tr></table></td></tr>';
  return html;
}
/* ─── Gut training note (v3.20) ──────────────────────
   Fires relative to the athlete's declared gut tolerance, not a fixed
   60 g/hr line — so a standard 90 g/hr rec to a robust gut stays silent
   instead of warning everyone. Baseline = trained carb ceiling by gut
   sensitivity; firm above baseline+15 (or any sodium target >1500),
   soft from baseline to +15, nothing below. */
function buildGutTrainingNoteHtml(r){
  var gut = state.gutSensitivity;
  var baseline = gut === 'robust' ? 90 : (gut === 'moderate' ? 75 : 55);
  var carbs  = (r && r.carbsPerHr  != null) ? r.carbsPerHr  : 0;
  /* v3.29: test what the gut is actually ASKED to absorb in-session (drink +
     capsules), not the sodium target. Once short mode zeroes capsules and the
     transition band caps them, the target is no longer what goes in — an
     athlete on 250 mg/hr of drink and one capsule was being warned about an
     1800 mg/hr load they never take. Recovery dosing isn't gut-limited in the
     same way: blood flow is restored and it's taken with volume. */
  var sodium = 0;
  if(r){
    sodium = (r.drinkSodium || 0) + (r.sodiumDeficit || 0);
    if(!r.shortMode && !r.transitionMode && r.sodiumPerHr != null) sodium = r.sodiumPerHr;
  }

  var prose;
  if(carbs > baseline + 15 || sodium > 1500){
    // Carb half of the advice only makes sense when carbs are actually prescribed.
    prose = carbs > 0
      ? '<strong>This plan asks more of your gut than your profile is currently adapted for.</strong> ' +
        'Carbohydrate absorption and sodium tolerance are both trainable — build them over weeks. ' +
        'Start 15–20 g/hr below these targets and add load each long session before you race with them.'
      : '<strong>This plan asks more sodium of your gut than your profile is currently adapted for.</strong> ' +
        'Sodium tolerance is trainable — build it over weeks. Take the in-session dose with plenty of fluid, ' +
        'and rehearse it in training before you race with it.';
  } else if(carbs > baseline){
    prose = 'You\'re near the top of your trained range. Run these numbers in training first, then race with them.';
  } else {
    return '';   // below baseline — no note
  }

  var html = '';
  html += '<tr><td style="padding:48px 40px 0;">';
  html += '<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">';
  html += '<tr><td style="border-left:2px solid #c79100;padding:4px 0 4px 20px;">';
  html += '<div style="font-family:\'IBM Plex Mono\',Courier New,monospace;font-size:10px;font-weight:600;letter-spacing:0.22em;color:#140049;margin-bottom:10px;">GUT TRAINING NOTE</div>';
  html += '<p style="font-size:15px;line-height:1.65;color:#0B0626;margin:0;">' + prose + '</p>';
  html += '</td></tr></table></td></tr>';
  return html;
}
/* Build in-page HTML for run-leg sodium note */
function buildRunSodiumNoteInPageHtml(note){
  if(!note) return '';
  var runMinLabel = durStrShort(Math.round(note.runHours * 60));
  var body;
  var leadLabel = note.drinkLabel.replace(/^your\s+/i, '');
  if(note.runDrinkLabel){
    if(note.runGap > 0){
      body = 'Your <strong>' + leadLabel + '</strong> covers your bike-leg sodium — but the run is different. ' +
             'On the run you\'ll be on <strong>' + note.runDrinkLabel + '</strong>, and you drink less from cups than from a bottle, so we count it at ~65% (' + note.runCreditPerHr + ' mg/hr). ' +
             'That leaves a gap — carry <strong>' + note.capsulesToCarry + ' ' + note.capsuleWord + '</strong> in a run-leg flask or race-belt pocket to top it up across the ' + runMinLabel + ' run. ' +
             'Confirm your race actually carries ' + note.runDrinkLabel + '; if not, carry more. Pack a spare in case you drop one.';
    } else {
      body = 'Your <strong>' + leadLabel + '</strong> covers your bike-leg sodium, and on the run you\'ll be on <strong>' + note.runDrinkLabel + '</strong> — even counted at ~65% for cup intake (' + note.runCreditPerHr + ' mg/hr) it covers the run target on its own. ' +
             'Carry <strong>' + note.capsulesToCarry + ' ' + note.capsuleWord + '</strong> as backup across the ' + runMinLabel + ' run, in case the race doesn\'t carry it or you drink less than planned. Confirm what your race actually serves.';
    }
  } else {
    body = 'Your <strong>' + leadLabel + '</strong> covers your bike-leg sodium target — but the run is different. ' +
           'Aid stations carry water and gels, not your bike drink, so your sodium supply line drops to zero the moment you rack the bike. ' +
           'Carry <strong>' + note.capsulesToCarry + ' ' + note.capsuleWord + '</strong> in a run-leg flask or race-belt pocket — that\'s your sodium plan for the ' + runMinLabel + ' run. Pack a spare in case you drop one.';
  }
  var html = '';
  html += '<div class="lw-his__guidance" style="border-left:2px solid var(--p-mint);padding-left:20px;margin:24px 0;">';
  html += '<div class="lw-his__guidance-label">Run leg — Sodium carry</div>';
  html += '<div class="lw-his__guidance-body">' + body + '</div></div>';
  return html;
}

/* Build pre-rendered HTML advisory block for email (v3.1.2 — CADENCE-style) */
function buildGatesEmailHtml(gates){
  if(!gates || !gates.length) return '';

  // Build a short prose summary describing what was flagged
  function gatePhrase(g){
    if(g.type === 'concentration') return 'sodium concentration';
    if(g.type === 'session_load_fluid') {
      var f = g.body.match(/(\d+\.?\d*)\s*L of fluid/);
      return f ? 'total fluid volume (' + f[1] + ' L)' : 'total fluid volume';
    }
    if(g.type === 'session_load_sodium') {
      var s = g.body.match(/(\d+\.?\d*)\s*g\)/);
      return s ? 'total sodium load (' + s[1] + ' g)' : 'total sodium load';
    }
    if(g.type === 'session_load_capsules') {
      var c = g.body.match(/(\d+)\s*capsules/);
      return c ? 'capsule cadence (' + c[1] + ' capsules)' : 'capsule cadence';
    }
    if(g.type === 'duration_experience') return 'session length relative to your current experience level';
    return '';
  }

  // Compose the prose from gate LABELS — direction-neutral (works for above-range,
  // too-dilute, and duration gates alike) and can never produce "undefined".
  var labels = gates.map(function(g){ return g.label; }).filter(function(l){ return l; });
  var labelList;
  if(labels.length === 0){
    labelList = 'a plan characteristic';
  } else if(labels.length === 1){
    labelList = labels[0];
  } else if(labels.length === 2){
    labelList = labels[0] + ' and ' + labels[1];
  } else {
    var lLast = labels.pop();
    labelList = labels.join(', ') + ', and ' + lLast;
  }
  var checkWord = gates.length === 1 ? 'check' : 'checks';
  var thisWord  = gates.length === 1 ? 'this' : 'these';
  var prose = 'This plan triggered ' + gates.length + ' advisory ' + checkWord +
              ' worth reviewing — ' + labelList + '. You acknowledged ' + thisWord +
              ' on the calculator before continuing — validate with a sweat test or sports-medicine input before relying on this plan for a key session.';

  // Render in the CADENCE block pattern with amber border
  var html = '';
  html += '<tr><td style="padding:48px 40px 0;">';
  html += '<table width="100%" cellpadding="0" cellspacing="0" border="0" role="presentation">';
  html += '<tr><td style="border-left:2px solid #c79100;padding:4px 0 4px 20px;">';
  html += '<div style="font-family:\'IBM Plex Mono\',Courier New,monospace;font-size:10px;font-weight:600;letter-spacing:0.22em;color:#140049;margin-bottom:10px;">ADVISORY ACKNOWLEDGED</div>';
  html += '<p style="font-size:15px;line-height:1.65;color:#0B0626;margin:0;">' + prose + '</p>';
  html += '</td></tr>';
  html += '</table>';
  html += '</td></tr>';
  return html;
}

/* Build advisory block for the persistent in-page banner */
function buildGatesInPageHtml(gates){
  if(!gates || !gates.length) return '';
  var html = '';
  html += '<ul style="list-style:none;padding:0;margin:14px 0 0;">';
  gates.forEach(function(g){
    html += '<li style="padding:10px 0 10px 18px;position:relative;font-size:0.85rem;line-height:1.6;color:var(--p-text-dim);border-bottom:1px solid rgba(255, 213, 107, 0.12);">';
    html += '<span style="position:absolute;left:0;top:18px;width:6px;height:6px;background:#ffd56b;display:inline-block;border-radius:50%;"></span>';
    html += '<strong style="display:block;margin-bottom:4px;color:var(--p-text);font-weight:500;font-size:0.88rem;">' + g.label + '</strong>';
    html += '<span>' + g.body + '</span>';
    html += '</li>';
  });
  html += '</ul>';
  return html;
}

  /* ─── MAIN CALCULATE ────────────────────────────────── */
  function calculate(){
    var sweatRate = calcSweatRate();
    var sodiumConc = calcSodiumConc();
    var sodiumPerHr = Math.round((sweatRate * sodiumConc * getReplacementPct()) / 100) * 100;
    var sodiumUncapped = sodiumPerHr;
    var sodiumCapped = false;
    if(sodiumPerHr > SODIUM_HR_CEILING){ sodiumPerHr = SODIUM_HR_CEILING; sodiumCapped = true; }
/* v3.40: rounding to the nearest 50 could push the figure back ABOVE the
   absorption ceiling it had just been clamped to (e.g. an 893 ml/hr ceiling
   printed as 900). Re-clamp after rounding. */
var fluidPerHr = Math.round(calcFluidTarget(sweatRate) / 50) * 50;
var fluidCeilNow = getFluidCeiling();
if(fluidPerHr > fluidCeilNow) fluidPerHr = Math.floor(fluidCeilNow / 50) * 50;
    var carbsPerHr = calcCarbTarget();
    var drinkSodium = 0;
    var drinkLabel = null;
    if(state.drinkSetup==='picker' && state.drinkProduct){
      drinkSodium = PRODUCT_PRESETS[state.drinkProduct].sodium;
      drinkLabel = PRODUCT_PRESETS[state.drinkProduct].label;
    } else if(state.drinkSetup==='custom'){
      drinkSodium = state.drinkSodiumMg || 0;
      drinkLabel = 'your drink (' + drinkSodium + ' mg/hr)';
    }
    // Run-leg drink (triathlon). Defaults to mirroring the bike drink; credited at
    // RUN_INTAKE_FACTOR on the run (cups vs bottle). 'none' = water/gels only (0 credit).
    var runDrinkSodium = 0, runDrinkLabel = null;
    if(state.sport==='triathlon' && (state.drinkSetup==='picker' || state.drinkSetup==='custom')){
      if(state.drinkProductRun === 'none'){
        runDrinkSodium = 0; runDrinkLabel = null;
      } else if(state.drinkProductRun && state.drinkProductRun !== 'same' && PRODUCT_PRESETS[state.drinkProductRun]){
        runDrinkSodium = PRODUCT_PRESETS[state.drinkProductRun].sodium;
        runDrinkLabel = PRODUCT_PRESETS[state.drinkProductRun].label;
      } else {
        runDrinkSodium = drinkSodium; runDrinkLabel = drinkLabel;
      }
    }
    var runDrinkCreditPerHr = Math.round(runDrinkSodium * RUN_INTAKE_FACTOR);
    var cap = calcCapsules(sodiumPerHr, drinkSodium);
    var hours = state.durationMin / 60;
    /* ─── Short-session overrides (v3.21) ─────────────
       Applied BEFORE totals so every downstream consumer (timeline,
       inventory, summary, payload, email) reconciles to one number. */
    var shortMode = null;
    if(isShortSession()){
      var smLossFluidMl = Math.round(sweatRate * 1000 * hours);
      var smLossSodiumMg = Math.round(sweatRate * sodiumConc * hours);
      var smAllow = shortSessionAllowance(sweatRate, sodiumConc, cap.perHr);
      var smInCaps = smAllow.allow;
      // Fluid: keep the physiological figure for cycling (bottle on the
      // bike is trivial) but cap the RUN display at 500 ml/hr — nobody
      // carries 850 ml on a sub-75-min run, and demanding it erodes trust.
      if(state.sport === 'run' && fluidPerHr > 500) fluidPerHr = 500;
      // Carbs (v3.23): carb fuelling starts at 75 min REGARDLESS of temperature,
      // but the short-mode window extends to 90 min in cool conditions (for
      // sodium, which can wait). So only zero carbs under 75 min — above that,
      // calcCarbTarget governs even while sodium is still in short mode. Hard
      // efforts keep their oral-effect dose; races keep carbs.
      if(state.durationMin < 75 && state.sessionType !== 'race' && state.intensity !== 'high') carbsPerHr = 0;
      // Recovery dose via the shared formula (v3.25).
      var smRec = computeRecovery(sweatRate, sodiumConc, hours, fluidPerHr, smInCaps);
      var smRecCaps = smRec.caps;
      var smRecFluid = smRec.fluidMl;
      // In-session capsules: override the deficit-driven rate with the
      // allowance total. Deficit is preserved for transparency display.
      cap = {
        perHr: smInCaps > 0 ? Math.round((smInCaps / hours) * 10) / 10 : 0,
        deficit: cap.deficit
      };
      shortMode = {
        active: true,
        inCaps: smInCaps,
        reason: smAllow.reason,
        recCaps: smRecCaps,
        recFluidMl: smRecFluid,
        lossFluidMl: smLossFluidMl,
        lossSodiumMg: smLossSodiumMg
      };
    }
    /* ─── Transition-band overrides (v3.25) ───────────
       75–150 min. In-session capsules capped at ~one per 45 min: at this
       duration the deficit is modest and the athlete is at their highest
       relative intensity, so a capsule every ~20 min is neither needed nor
       swallowable. The balance is not dropped — it moves to pre-load and
       recovery, which the phase logic now provides for this band. */
    var transitionMode = null;
    if(!shortMode && isTransitionSession()){
      var tmUncapped = Math.ceil(cap.perHr * hours);
      /* Taper, not a step (v3.33). A flat "one per 45 min" cap across the whole
         band left a cliff at the top: 2h25 returned 3 capsules and 2h30 returned
         8, because the uncapped protocol resumed all at once. The need for
         in-session sodium ramps with duration while relative intensity — and so
         the gut limit — eases, so the allowance ramps linearly from one per
         45 min at 75 min to the full uncapped rate at 150 min. */
      var tmT = Math.max(0, Math.min(1, (state.durationMin - 75) / 75));
      var tmAllowedPerHr = (1 - tmT) * (60 / 45) + tmT * cap.perHr;
      var tmInCaps = Math.min(tmUncapped, Math.max(1, Math.round(tmAllowedPerHr * hours)));
      var tmRec = computeRecovery(sweatRate, sodiumConc, hours, fluidPerHr, tmInCaps);
      cap = {
        perHr: tmInCaps > 0 ? Math.round((tmInCaps / hours) * 10) / 10 : 0,
        deficit: cap.deficit
      };
      transitionMode = {
        active: true,
        inCaps: tmInCaps,
        uncapped: tmUncapped,
        capped: tmInCaps < tmUncapped,
        recCaps: tmRec.caps,
        recFluidMl: tmRec.fluidMl,
        lossFluidMl: tmRec.lossFluidMl,
        lossSodiumMg: tmRec.lossSodiumMg
      };
    }
    var exactDeficit = (drinkSodium >= sodiumPerHr * 0.95) ? 0 : (sodiumPerHr - drinkSodium);
    var exactCapsPerHr = exactDeficit > 0 ? (exactDeficit / CAPSULE_NA) : 0;
    var totals = {
      fluid: Math.round(fluidPerHr * hours),
      sodium: Math.round(sodiumPerHr * hours),
      carbs: Math.round(carbsPerHr * hours),
      /* Session capsules from the UNROUNDED hourly deficit (v3.34). Deriving
         them from cap.perHr — which is rounded to 1 dp for display — let the
         truncation compound across the session: a 2.03/hr requirement became
         2.0/hr and delivered 40 mg under target across 4 h. Small, but it meant
         the plan occasionally under-shot the very target it printed. */
      capsules: Math.round((exactCapsPerHr * hours) * 100) / 100
    };
    // Short mode: pin the in-session capsule total to the exact allowance —
    // never let rate×hours rounding drift it to 0.9 or 1.1.
    if(shortMode) totals.capsules = shortMode.inCaps;
    if(transitionMode) totals.capsules = transitionMode.inCaps;
    /* Sodium total (v3.26) — what the athlete actually INGESTS during the
       session (drink + capsules), not target x hours. The two used to be
       interchangeable because capsules were always sized to close the gap;
       once short mode zeroes them and the transition band caps them, a totals
       row reading "975 mg" beside "0 capsules" is simply untrue. The target
       still appears in its own right in the sodium-strategy table, and the
       unreplaced balance is carried by the recovery block. */
    var wholeCaps = Math.ceil(totals.capsules);
    totals.sodium = Math.round(drinkSodium * hours + wholeCaps * CAPSULE_NA);
    // Same correction per-hour: this row is labelled "remaining gap from
    // capsules", so it must state what the capsules deliver, not what the
    // deficit was before capping.
    var capsuleSodiumPerHr = hours > 0 ? Math.round((wholeCaps * CAPSULE_NA) / hours) : 0;
    cap.deficit = capsuleSodiumPerHr;
    /* v3.41: derive the tri legs from the canonical base split rather than
       rescaling whatever is currently in state. The old version normalised the
       LIVE leg values against durationMin on every calc, so any calc that ran
       while the legs were half-written (see the format handler) permanently
       baked a wrong shape into state. */
if(state.sport === 'triathlon') applyTriSplit();
var triBreakdown = (state.sport === 'triathlon') ? calcTriBreakdown(fluidPerHr, sodiumPerHr, carbsPerHr, cap.perHr) : null;
var concBand = classifyConc(sodiumPerHr, fluidPerHr);
    var r = {
  sweatRate: sweatRate,
  sodiumConc: sodiumConc,
  sodiumPop: classifySodiumPopulation(sodiumConc),
  sodiumPerHr: sodiumPerHr,
  replacementPct: getReplacementPct(),
  sodiumCapped: sodiumCapped,
  sodiumUncapped: sodiumUncapped,
  fluidPerHr: fluidPerHr,
  carbsPerHr: carbsPerHr,
  drinkSodium: drinkSodium,
  drinkLabel: drinkLabel,
  runDrinkSodium: runDrinkSodium,
  runDrinkLabel: runDrinkLabel,
  runDrinkCreditPerHr: runDrinkCreditPerHr,
  capsulesPerHr: cap.perHr,
  sodiumDeficit: cap.deficit,
  hours: hours,
  totals: totals,
  triBreakdown: triBreakdown,
  concBand: concBand,
  confidence: calcConfidence(),
  assumptions: buildAssumptions(),
  drinkCovers: drinkSodium >= sodiumPerHr * 0.95,
  fluidCeiling: getFluidCeiling(),
  shortMode: shortMode,
  transitionMode: transitionMode
};
// Compute gates AFTER r is assembled, so gate functions have access to all derived values
r.gates = getGates(r);
r.runSodiumNote = buildRunSodiumGapNote(r);
r.sodiumValidationNote = buildSodiumValidationNote(r);   // soft, non-blocking (v3.16)
r.fluidCeilingNote = buildFluidCeilingNote(r);           // soft, non-blocking (v3.18)
// When the run-leg sodium note fires, the bike drink doesn't reach the run, so the run
// carries its full sodium as capsules. Fold that into the in-session total so timeline,
// inventory, summary, and email all reconcile to one number. The bike keeps whatever the
// per-hour rate gives it; the run takes its full need. The existing bike/run split
// (round(cphr*triBike) for the bike, remainder for the run) then reproduces both legs.
if(state.sport === 'triathlon'){
  // Per-leg capsule split: the swim takes none, so the session total is the bike
  // leg plus the run leg — never rate × total hours, which charges a phantom swim
  // hour and then dumps those capsules onto the run as a leftover remainder.
  var bikeLegCaps = Math.max(0, Math.round(r.capsulesPerHr * state.triBike));
  if(r.runSodiumNote){
    // Bike drink isn't on the run course — run carries its full sodium as capsules.
    r.totals.capsules = bikeLegCaps + r.runSodiumNote.capsulesToCarry;
    r.legSplit = { bike: bikeLegCaps, run: r.runSodiumNote.capsulesToCarry };
  } else {
    var runLegCaps = Math.max(0, Math.round(r.capsulesPerHr * state.triRun));
    r.totals.capsules = bikeLegCaps + runLegCaps;
    r.legSplit = { bike: bikeLegCaps, run: runLegCaps };
  }
  /* v3.31: totals.sodium was computed upstream from the pre-split capsule
     count, so the per-leg rounding above left it stale for triathlon. Recompute
     from what's actually swallowed: no intake on the swim, full drink credit on
     the bike, run drink credited at RUN_INTAKE_FACTOR (cups vs bottle), plus the
     leg-split capsules. */
  var triDrinkNa = (r.drinkSodium || 0) * state.triBike +
                   (r.runDrinkCreditPerHr != null ? r.runDrinkCreditPerHr : (r.drinkSodium || 0) * RUN_INTAKE_FACTOR) * state.triRun;
  r.totals.sodium = Math.round(triDrinkNa + Math.ceil(r.totals.capsules) * CAPSULE_NA);
}
r.unsafeFlag = r.gates.length > 0;  // preserved for backwards compatibility
return r;
  }

  /* ─── UPDATE LIVE PREVIEW ───────────────────────────── */
  function updatePreview(){
    /* v3.35: the preview previously recomputed its numbers independently and
       drifted from calculate() three times (short-mode zeroing, the sodium
       ceiling, the transition taper — each had to be re-taught). It now reads
       the same engine the results page uses, so it CANNOT disagree. */
    var r = calculate();
    var pvSweat = $('#pvSweat'); if(pvSweat) pvSweat.textContent = fmt(r.sweatRate, 2);
    var pvFluid = $('#pvFluid'); if(pvFluid) pvFluid.textContent = fmt(r.fluidPerHr);
    var pvSodium = $('#pvSodium'); if(pvSodium) pvSodium.textContent = fmt(r.sodiumPerHr);
    var pvCarb = $('#pvCarb'); if(pvCarb) pvCarb.textContent = fmt(r.carbsPerHr);
    var pvCap = $('#pvCapsule'); if(pvCap) pvCap.textContent = fmt(r.capsulesPerHr, 1);
    var c1 = state.weight!=null;
    var c2 = true; // env defaults
    var c3 = true; // sweat defaults
    var c4 = state.durationMin!=null;
    var pvc1 = $('#pvc1'); if(pvc1) pvc1.classList.toggle('is-complete', c1);
    var pvc2 = $('#pvc2'); if(pvc2) pvc2.classList.toggle('is-complete', c2);
    var pvc3 = $('#pvc3'); if(pvc3) pvc3.classList.toggle('is-complete', c3);
    var pvc4 = $('#pvc4'); if(pvc4) pvc4.classList.toggle('is-complete', c4);
    updateRunDrinkVisibility();
  }

  /* Show the run-drink picker only when it actually drives the numbers:
     triathlon half/full with a bike drink that covers the bike (>=85% of target),
     i.e. exactly when the run-leg sodium note fires. Hidden otherwise so the
     control is never present-but-inert. */
  function updateRunDrinkVisibility(){
    var g = $('#lwRunDrinkGroup');
    if(!g) return;
    var isTriLong = state.sport === 'triathlon' && (state.triFormat === 'half' || state.triFormat === 'full');
    var dSod = 0;
    if(state.drinkSetup === 'picker' && state.drinkProduct && PRODUCT_PRESETS[state.drinkProduct]) dSod = PRODUCT_PRESETS[state.drinkProduct].sodium;
    else if(state.drinkSetup === 'custom') dSod = state.drinkSodiumMg || 0;
    var sr = calcSweatRate();
    var sc = calcSodiumConc();
    var sodiumHr = Math.round((sr * sc * getReplacementPct()) / 100) * 100;
    var covers = sodiumHr > 0 && dSod >= sodiumHr * 0.85;
    g.style.display = (isTriLong && covers) ? 'block' : 'none';
  }

  /* ─── STEP NAVIGATION ───────────────────────────────── */
  function goToStep(n){
    state.step = n;
    $$('.lw-his__step').forEach(function(s){
      s.classList.toggle('is-active', parseInt(s.dataset.step) === n);
    });
    $$('.lw-his__progress-step').forEach(function(s){
      var sn = parseInt(s.dataset.step);
      s.classList.remove('is-active', 'is-complete');
      if(sn === n) s.classList.add('is-active');
      else if(sn < n) s.classList.add('is-complete');
    });
    var fill = $('#lwProgressFill');
    if(fill) fill.style.width = (n*20) + '%';
    // Toggle the full-bleed Step 5 wrapper and hide the input layout when on step 5
    var fb = document.getElementById('lwProtocolFullBleed');
    var layout = root.querySelector('.lw-his__layout');
    var pv = $('#lwPreviewCol');
    if(n === 5){
      if(fb) fb.classList.add('is-active');
      if(layout) layout.style.display = 'none';
      if(pv) pv.classList.add('is-hidden');
      var r = calculate();
      state.results = r;
      lwStoreProfile(r);
      renderResults(r);
    } else {
      if(fb) fb.classList.remove('is-active');
      if(layout) layout.style.display = '';
      if(pv) pv.classList.remove('is-hidden');
      // Reset the acknowledgement banner so it doesn't persist after edits
      var ackBanner = $('#lwAckBanner');
      if(ackBanner) ackBanner.classList.remove('is-active');
    }
    // Scroll to the top of the active step content with header offset
    setTimeout(function(){
      var target;
      if(n === 5){
        target = document.getElementById('lwProtocolFullBleed');
      } else {
        target = root.querySelector('.lw-his__step.is-active');
      }
      if(target){
        var rect = target.getBoundingClientRect();
        var headerOffset = 100; // clears Impulse V2 sticky header
        window.scrollTo({ top: window.pageYOffset + rect.top - headerOffset, behavior: 'smooth' });
      }
    }, 30);
  }

  /* ════════════════════════════════════════════════════════
     V4-FAITHFUL RENDER FUNCTIONS
  ════════════════════════════════════════════════════════ */

  function determinePhases(r){
    // Short-session mode (v3.21): recovery becomes the primary replacement
    // phase. Pre-load: 'reduced' for short races (start replete — no mid-
    // event recovery window), 'light' for short training in heat (the
    // highest-leverage lever for a short hot session sits before the start),
    // none otherwise.
    if(r && r.shortMode){
      var smPre = 'none';
      if(state.sessionType === 'race') smPre = 'reduced';
      else if(hasHeatStressor()) smPre = 'light';
      return { pre: smPre, inSession: true, post: 'recovery-primary' };
    }
    var isRace = state.sessionType === 'race';
    var heatStressor = state.tempC >= 25 || state.humidity === 'high' || state.heatAcclim === 'none';
    /* Transition band (v3.25): 75–150 min. Previously this fell through the
       cracks — a race here got pre:none AND post:none (the old isShort test
       required >=90), i.e. every capsule crammed into the effort itself with
       nothing either side. That is backwards: this is the band where
       pre-loading has the most leverage and in-session capacity is lowest.
       Race starts replete (reduced pre-load); training doesn't pre-load
       routinely unless it's hot. Both get a scaled recovery block. */
    if(r && r.transitionMode){
      var tPre = 'none';
      if(isRace) tPre = 'reduced';
      else if(heatStressor) tPre = 'light';
      return { pre: tPre, inSession: true, post: 'recovery-scaled' };
    }
    var isLong = state.durationMin >= 180;
    var phases = { pre: 'none', inSession: true, post: 'none' };
    // Pre-load (v3.25): every race starts replete. Previously only long races
    // (or medium+heat) pre-loaded, which left a cliff — a 2h29 race pre-loaded
    // and a 2h30 race didn't. Full protocol is reserved for long races in heat;
    // everything else races on the reduced load. Training doesn't pre-load
    // routinely: it's neither necessary nor practical several times a week.
    if(isRace && isLong && heatStressor) phases.pre = 'full';
    else if(isRace) phases.pre = 'reduced';
    else phases.pre = 'none';
    if(isRace && isLong) phases.post = 'full';
    else if(isRace) phases.post = 'single';
    // Training 150 min+ (v3.25): a 3 h ride leaves a deficit measured in
    // grams and you train again tomorrow — chronic accumulation is the
    // training-specific risk, so recovery is no longer omitted until 4 h.
    else if(!isRace && state.durationMin >= 150) phases.post = 'single';
    else phases.post = 'none';
    return phases;
  }

  function buildSummary(r){
    var sportLabels = { run:'Run', cycle:'Cycle', swim:'Swim', triathlon:'Triathlon', other:'Endurance' };
    var sport = sportLabels[state.sport] || 'Session';
    var type = state.sessionType === 'race' ? 'race' : 'training session';
    var dur = durStr(state.durationMin);
    var tempStr = state.tempUnit === 'f' ? Math.round(state.tempC*1.8+32)+'°F' : state.tempC+'°C';
    var humidStr = state.humidity === 'low' ? 'low humidity' : (state.humidity === 'high' ? 'high humidity' : 'moderate humidity');
    var triFormat = '';
    if(state.sport === 'triathlon'){
      var triFmtLabels = { sprint:' (Sprint)', olympic:' (Olympic)', half:' (70.3)', full:' (140.6)' };
      triFormat = triFmtLabels[state.triFormat] || '';
    }
    var capsTotalSum = Math.ceil(r.totals.capsules);
var capsToken = capsTotalSum > 0 ? '<strong>'+capsTotalSum+' capsule'+(capsTotalSum===1?'':'s')+'</strong> total &nbsp;·&nbsp; ' : '';
return '<strong>'+dur+' '+sport+triFormat+'</strong> '+type+' &nbsp;·&nbsp; <strong>'+r.fluidPerHr+' ml/hr</strong> fluid, <strong>'+r.sodiumPerHr+' mg/hr</strong> sodium target, <strong>'+r.carbsPerHr+' g/hr</strong> carbs &nbsp;·&nbsp; '+capsToken+tempStr+', '+humidStr+'.';
  }

  /* V4 row: time column + items column with capsule + fluid items */
  function v4Row(time, sub, items, annotation){
    var html = '<div class="lw-his__t-row'+(annotation ? ' has-annotation' : '')+'">';
    html += '<div class="lw-his__t-time">'+time+(sub ? '<small>'+sub+'</small>' : '')+'</div>';
    html += '<div class="lw-his__t-items">'+items+'</div>';
    html += '</div>';
    if(annotation){
      html += '<div class="lw-his__t-row-annotation"><div></div><div class="lw-his__t-row-annotation-body">'+annotation+'</div></div>';
    }
    return html;
  }

  /* V4 item builder: capsule, fluid, drink-named */
  function v4Item(type, qty, label, productName){
    if(type === 'capsule'){
      return '<span class="lw-his__t-item lw-his__t-item--capsule"><span class="lw-his__t-item-qty">'+qty+'</span><span>'+label+'</span></span>';
    }
    if(type === 'drink-named'){
      return '<span class="lw-his__t-item lw-his__t-item--drink-named"><span class="lw-his__t-item-qty">'+qty+'</span><span>ml</span><span class="lw-his__t-item-product">'+productName+'</span></span>';
    }
    // plain fluid
    return '<span class="lw-his__t-item"><span class="lw-his__t-item-qty">'+qty+'</span><span>'+label+'</span></span>';
  }

  function v4Segment(name, meta){
    return '<div class="lw-his__segment-mark"><div class="lw-his__segment-mark-label">'+name+'</div><div class="lw-his__segment-mark-rule"></div><div class="lw-his__segment-mark-meta">'+meta+'</div></div>';
  }

  function v4Guidance(label, body){
    return '<div class="lw-his__guidance"><div class="lw-his__guidance-label">'+label+'</div><div class="lw-his__guidance-body">'+body+'</div></div>';
  }

  function buildItems(capCount, fluidMl, drinkLabel, carbsG){
    var items = '';
    if(capCount > 0){
      var n = capCount === 1 ? '1' : capCount.toString();
      items += v4Item('capsule', n, capCount === 1 ? 'capsule' : 'capsules');
    }
    if(fluidMl > 0){
      if(drinkLabel && drinkLabel !== 'water'){
        items += v4Item('drink-named', fluidMl, '', drinkLabel);
      } else {
        items += v4Item('fluid', fluidMl, 'ml water');
      }
    }
    if(carbsG && carbsG > 0){
      items += v4Item('fluid', carbsG, 'g carbs');
    }
    return items;
  }

  function buildAnnotation(r, capCount){
    if(r.drinkSodium <= 0 || !r.drinkLabel) return null;
    var capMg = capCount * CAPSULE_NA;
    var total = r.drinkSodium + capMg;
    if(capCount === 0){
      return '<strong>'+r.drinkSodium+' mg from drink</strong> = '+total+' mg sodium for the hour';
    }
    return '+'+r.drinkSodium+' mg drink, +'+capMg+' mg capsule = <strong>'+total+' mg sodium</strong>';
  }
  // Distribute whole capsules across a segment's hourly rows so the per-row
// counts always sum exactly to totalCaps. Sparse plans place single capsules
// at even centroid positions (protects the pre-loaded opening hour and the
// dying minutes); denser plans spread multiples per row. (v3.3)
function distributeCapsules(totalCaps, totalMin, rows){
  var out = [];
  for(var i = 0; i < rows; i++) out.push(0);
  if(totalCaps <= 0 || rows <= 0) return out;
  if(totalCaps >= rows){
    var prev = 0;
    for(var i = 1; i <= rows; i++){
      var cum = Math.round(totalCaps * i / rows);
      out[i-1] = cum - prev;
      prev = cum;
    }
    return out;
  }
  for(var k = 1; k <= totalCaps; k++){
    var t = ((k - 0.5) / totalCaps) * totalMin;
    var row = Math.floor(t / 60) + 1;
    if(row < 1) row = 1;
    if(row > rows) row = rows;
    while(out[row-1] > 0 && row < rows) row++;
    while(out[row-1] > 0 && row > 1) row--;
    out[row-1] += 1;
  }
  return out;
}

  function buildCadenceText(capsPerHr, drinkLabel, hasCarbs, totalCaps, durationMin){
  if(capsPerHr <= 0 || !totalCaps || totalCaps <= 0){
    return '<strong>Drink steadily — '+drinkLabel+' is covering your sodium.</strong> No capsules needed for the in-session segments; sodium target is met by the drink.';
  }
  if(capsPerHr >= 1){
    if(capsPerHr <= 1.15){
      return '<strong>One capsule per hour</strong>, taken mid-hour with fluid. Drink continuously — small sips every 10–15 minutes rather than gulps at aid stations.';
    }
    var iv = Math.round(60 / capsPerHr / 5) * 5;
    if(iv < 10) iv = 10;
    return '<strong>One capsule every '+iv+' min</strong>, spaced evenly. Don\'t front-load — sodium absorption is rate-limited.';
  }
  var capCentroid = function(k){ return Math.round(((k - 0.5) / totalCaps * durationMin) / 5) * 5; };
  if(totalCaps === 1){
    return '<strong>One capsule across the whole session</strong>, taken around ' + durStrShort(capCentroid(1)) + ' in, with fluid. Your drink carries the rest of your sodium.';
  }
  if(totalCaps === 2){
    return '<strong>Two capsules across the session</strong> — one around ' + durStrShort(capCentroid(1)) + ', the second around ' + durStrShort(capCentroid(2)) + ', both with fluid. Your drink carries the rest of your sodium.';
  }
  var gapMin = Math.round((durationMin / totalCaps) / 5) * 5;
  var gapLabel;
  if(gapMin >= 90){
    var gapHr = Math.round((gapMin / 60) * 2) / 2;
    gapLabel = (gapHr % 1 === 0 ? gapHr.toFixed(0) : gapHr) + ' h';
  } else {
    gapLabel = gapMin + ' min';
  }
  return '<strong>'+totalCaps+' capsules across the session</strong>, spaced roughly '+gapLabel+' apart and taken with fluid — your drink carries the rest. Don\'t front-load them.';
}

  /* Fluid-access phrasing keyed to the Step 4 "Fluid Access During Session"
     selector (state.aidStation), so cadence guidance never assumes aid stations
     the athlete told us they won't have. */
  function fluidAccessNote(){
    if(state.aidStation === 'carry'){
      return 'You\'re carrying all your fluid — sip to a schedule, every 10–15 min, rather than waiting for stations.';
    }
    if(state.aidStation === 'infrequent'){
      return 'Fluid access is sparse (60+ min apart) — carry enough to bridge each gap.';
    }
    return 'Aid stations are regular (every 20–30 min) — take fluid at each one.';
  }

  function getDrinkLabel(r){
    return r.drinkLabel || 'water';
  }

  /* PRE-SESSION PHASE */
  function renderPreSession(r, mode){
    if(mode === 'none') return '';
    var html = '<div class="lw-his__phase">';
    html += '<div class="lw-his__phase-header"><div class="lw-his__phase-header-left">';
    html += '<span class="lw-his__phase-label">Phase 01</span>';
    html += '<h2 class="lw-his__phase-title">Pre-session</h2>';
    html += '</div><div class="lw-his__phase-meta">'+(mode==='full'?'Day before + race morning':(mode==='light'?'60–90 min before':'Race morning'))+'</div></div>';
    if(mode === 'light'){
      html += '<p class="lw-his__phase-intro">Short session, hot conditions — the highest-leverage move happens before you start. The session itself is too short for meaningful replacement, so arrive topped up.</p>';
      html += '<div class="lw-his__timeline">';
      html += v4Row('60–90 min before', 'Pre-load', v4Item('capsule', '1', 'capsule') + v4Item('fluid', '400–600', 'ml water'));
      html += '</div>';
      html += '</div>';
      return html;
    }
    if(mode === 'full'){
      html += '<p class="lw-his__phase-intro">Heat plus duration means you should arrive at the start line with elevated plasma sodium and good hydration status. This is the small window where pre-loading actually moves the dial.</p>';
      html += '<div class="lw-his__timeline">';
      html += v4Row('Night before', 'Evening meal', v4Item('fluid', 'Salt', 'your dinner') + v4Item('fluid', '500', 'ml water with dinner'));
      html += v4Row('Race morning', '90 min pre-start', v4Item('capsule', '2', 'capsules') + v4Item('fluid', '500', 'ml water'));
      html += v4Row('Warm-up', '15 min pre-start', v4Item('capsule', '1', 'capsule') + v4Item('fluid', '250', 'ml water'));
      html += '</div>';
    } else {
      html += '<p class="lw-his__phase-intro">A reduced pre-load: enough to start sodium-replete without overdoing it.</p>';
      html += '<div class="lw-his__timeline">';
      html += v4Row('Race morning', '60–90 min pre-start', v4Item('capsule', '1', 'capsule') + v4Item('fluid', '400', 'ml water'));
      html += v4Row('Warm-up', '15 min pre-start', v4Item('capsule', '1', 'capsule') + v4Item('fluid', '250', 'ml water'));
      html += '</div>';
    }
    html += '</div>';
    return html;
  }

  /* IN-SESSION PHASE — sport-aware */
  function renderInSession(r){
    var phases = determinePhases(r);
    var html = '<div class="lw-his__phase">';
    html += '<div class="lw-his__phase-header"><div class="lw-his__phase-header-left">';
    html += '<span class="lw-his__phase-label">Phase '+(phases.pre==='none'?'01':'02')+'</span>';
    html += '<h2 class="lw-his__phase-title">In-session</h2>';
    html += '</div><div class="lw-his__phase-meta">'+durStr(state.durationMin)+' total</div></div>';

    if(r.shortMode){
      var smIntro = r.shortMode.inCaps > 0
        ? 'At this duration, sweat losses don\'t shift blood sodium enough to limit performance mid-session. One capsule is included — ' + r.shortMode.reason + ' — beyond that, drink to thirst. The bulk of replacement happens in recovery.'
        : 'At this duration, sweat losses don\'t shift blood sodium enough to limit performance mid-session — sweat is more dilute than plasma, so blood sodium holds for the hour even at high sweat rates. Drink to thirst. Replacement happens in recovery, where it actually counts.';
      if(r.carbsPerHr === 0){
        smIntro += ' No carbohydrate needed at this duration — fuel normally beforehand and it\'s covered.';
      }
      html += '<p class="lw-his__phase-intro">'+smIntro+'</p>';
    } else if(phases.pre === 'none'){
      var preNote = state.sessionType === 'race'
        ? 'This session is short enough that starting well-hydrated through normal meals is sufficient. Pre-loading isn\'t required — focus on in-session execution.'
        : 'Pre-loading isn\'t required for training. Start hydrated and execute the protocol below.';
      html += '<p class="lw-his__phase-intro">'+preNote+'</p>';
    }

    var drinkLabel = getDrinkLabel(r);
    var capsPerHr = r.capsulesPerHr;
    

    html += '<div class="lw-his__timeline">';

    if(state.sport === 'triathlon'){
  // Capsules distributed WITHIN the bike and run legs (swim = none).
  // Split the in-session total so bike + run sum exactly to inventory.
  var inSessionCaps = Math.ceil(r.totals.capsules);
  var bikeCaps = Math.round(r.capsulesPerHr * state.triBike);
  if(bikeCaps > inSessionCaps) bikeCaps = inSessionCaps;
  if(bikeCaps < 0) bikeCaps = 0;
  var runCaps = inSessionCaps - bikeCaps;
  if(runCaps < 0) runCaps = 0;

  // SWIM
  var swimMin = Math.round(state.triSwim * 60);
  html += v4Segment('Swim', durStr(swimMin));
  html += v4Row('Swim leg', 'No intake', '<span class="lw-his__t-item">No fuel or fluid during swim. Protocol starts at T1.</span>');

  // BIKE
  var bikeMin = Math.round(state.triBike * 60);
  var bikeHours = Math.ceil(state.triBike);
  var bikeDist = distributeCapsules(bikeCaps, bikeMin, bikeHours);
  html += v4Segment('Bike', durStr(bikeMin));
  html += v4Row('T1', 'Transition', v4Item('fluid', '250', 'ml water'));
  var bikeFluid = Math.round(r.fluidPerHr);
  var bikeCarbs = Math.round(r.carbsPerHr);
  for(var bh=1; bh<=bikeHours; bh++){
    var bhLabel = bh + ' — ' + (bh+1) + ' h';
    if(bh === bikeHours){ bhLabel = (bh-1) + ' h — T2'; }
    else if(bh === 1){ bhLabel = '0 — 1 h'; }
    var bsub = bh === 1 ? 'Bike opening' : (bh === bikeHours ? 'Bike close' : 'Bike mid');
    var bCap = bikeDist[bh-1] || 0;
    var bitems = buildItems(bCap, bikeFluid, drinkLabel, bikeCarbs);
    var bannot = buildAnnotation(r, bCap);
    html += v4Row(bhLabel, bsub, bitems, bannot);
  }
  html += v4Guidance('Bike cadence', buildCadenceText(capsPerHr, drinkLabel, true, bikeCaps, bikeMin));

  // RUN
  var runMin = Math.round(state.triRun * 60);
  var runHours = Math.ceil(state.triRun);
  var runDist = distributeCapsules(runCaps, runMin, runHours);
  html += v4Segment('Run', durStr(runMin));
  if(state.results && state.results.runSodiumNote){
    html += buildRunSodiumNoteInPageHtml(state.results.runSodiumNote);
  }
  html += v4Row('T2', 'Transition', v4Item('fluid', '200', 'ml water'));
  var runFluid = Math.round(r.fluidPerHr * 0.9);
  var runCarbs = Math.round(r.carbsPerHr * 0.95);
  // When the run-leg note fired, the bike drink isn't on the run course: run fluid is
  // aid-station water, sodium comes from the carried capsules, carbs from gels. Render
  // the rows that way so they match the carry note instead of claiming drink sodium.
  var runNote = (state.results && state.results.runSodiumNote) ? state.results.runSodiumNote : null;
  var runHasDrink = !!(runNote && runNote.runDrinkLabel);
  var runFluidLabel = runNote ? (runHasDrink ? runNote.runDrinkLabel : 'water') : drinkLabel;
  var runCreditPerHr = runNote ? (runNote.runCreditPerHr || 0) : 0;
  for(var rh=1; rh<=runHours; rh++){
    var rhLabel = rh + ' — ' + (rh+1) + ' h run';
    if(rh === 1) rhLabel = '0 — 1 h run';
    if(rh === runHours && runHours > 1) rhLabel = (rh-1) + ' — ' + rh + ' h run';
    var rsub = rh === 1 ? 'First half' : (rh === runHours ? 'To finish' : 'Mid-run');
    var rCap = runDist[rh-1] || 0;
    var ritems = buildItems(rCap, runFluid, runFluidLabel, runCarbs);
    var rannot;
    if(runNote){
      var rCapMg = rCap * CAPSULE_NA;
      if(runHasDrink){
        var rTot = runCreditPerHr + rCapMg;
        rannot = rCap > 0
          ? '+' + runCreditPerHr + ' mg run drink, +' + rCapMg + ' mg capsule = <strong>' + rTot + ' mg sodium</strong>'
          : '<strong>' + runCreditPerHr + ' mg sodium</strong> from your run drink this hour';
      } else {
        rannot = rCap > 0
          ? '<strong>' + rCapMg + ' mg sodium</strong> from capsules — aid-station water carries none'
          : null;
      }
    } else {
      rannot = buildAnnotation(r, rCap);
    }
    html += v4Row(rhLabel, rsub, ritems, rannot);
  }
  // When the run-leg sodium carry note has fired, the drink covered the bike but
  // won't be on the run — so the cadence must defer to the carry note above rather
  // than say "no capsules needed". Otherwise use the normal cadence text.
  var runCadenceText;
  if(state.results && state.results.runSodiumNote){
    var rn = state.results.runSodiumNote;
    if(rn.runDrinkLabel){
      runCadenceText = '<strong>Your bike drink isn\'t on the run — you\'ll be on ' + rn.runDrinkLabel + ', counted at ~65% for cup intake.</strong> Take the run-leg capsules above with fluid, spread evenly, to top up the gap.';
    } else {
      runCadenceText = '<strong>Your drink covered the bike, but it\'s not on the run course.</strong> Take the run-leg capsules above with fluid, spread evenly across the run — that\'s your sodium here, not the aid-station drink.';
    }
  } else {
    runCadenceText = buildCadenceText(capsPerHr, drinkLabel, true, runCaps, runMin);
  }
  html += v4Guidance('Run cadence', runCadenceText + ' ' + fluidAccessNote());

} else {
  // SINGLE-SPORT
  var totalMin = state.durationMin;
  var hours = Math.ceil(totalMin / 60);
  var hourlyFluid = Math.round(r.fluidPerHr);
  var hourlyCarbs = Math.round(r.carbsPerHr);
  var inSessionCaps = Math.ceil(r.totals.capsules);

  if(totalMin < 75){
    var capDist = distributeCapsules(inSessionCaps, totalMin, 1);
    var sitems = buildItems(capDist[0], hourlyFluid, drinkLabel, hourlyCarbs);
    html += v4Row('Whole session', durStr(totalMin), sitems, buildAnnotation(r, capDist[0]));
  } else {
    var capDist = distributeCapsules(inSessionCaps, totalMin, hours);
    for(var hh=1; hh<=hours; hh++){
      var hhLabel;
      if(hh === 1) hhLabel = '0 — 1 h';
      else if(hh === hours && totalMin % 60 !== 0) hhLabel = (hh-1)+' h — finish';
      else hhLabel = (hh-1)+' — '+hh+' h';
      var hsub = hh === 1 ? 'Opening' : (hh === hours ? 'Closing' : 'Hour '+hh);
      var capThis = capDist[hh-1] || 0;
      var hitems = buildItems(capThis, hourlyFluid, drinkLabel, hourlyCarbs);
      var hannot = buildAnnotation(r, capThis);
      html += v4Row(hhLabel, hsub, hitems, hannot);
    }
  }
  // Drink-dependency caveat (single sport): when the drink alone covers the sodium
  // target (zero capsules) and it's a named drink, warn that the plan leans on that
  // drink being on course — and give a capsule backup figure. Mirrors the tri run note.
  var sessionCadence;
  if(r.shortMode){
    sessionCadence = r.shortMode.inCaps > 0
      ? '<strong>One capsule mid-session, taken with fluid.</strong> Included because of ' + r.shortMode.reason + '. Beyond that, drink to thirst — don\'t force intake to a schedule at this duration.'
      : '<strong>No capsules during this session.</strong> The duration doesn\'t create an in-session sodium requirement — your deficit is real, but it\'s replaced in the recovery window below, not mid-session. Drink to thirst.';
  } else if(r.transitionMode && r.transitionMode.capped){
    sessionCadence = buildCadenceText(capsPerHr, drinkLabel, true, inSessionCaps, totalMin) +
      ' <strong>Held to ' + r.transitionMode.inCaps + ' during the session on purpose.</strong> At this length you\'re at your highest relative intensity, so intake capacity is at its lowest — the balance of the deficit is covered by the pre-load and recovery blocks rather than forced into the effort. ' + fluidAccessNote();
  } else {
    sessionCadence = buildCadenceText(capsPerHr, drinkLabel, true, inSessionCaps, totalMin) + ' ' + fluidAccessNote();
  }
  if(!r.shortMode && inSessionCaps <= 0 && drinkLabel && drinkLabel !== 'water'){
    var backupCaps = Math.ceil((r.sodiumPerHr * (totalMin / 60)) / CAPSULE_NA) + 1;
    sessionCadence += ' <strong>One caveat:</strong> this assumes ' + drinkLabel +
      ' is on hand the whole way. Many events stock water and gels, not ' + drinkLabel +
      ' — if you can\'t count on it, carry <strong>' + backupCaps + ' capsules</strong> as your sodium backup.';
  }
  html += v4Guidance('Session cadence', sessionCadence);
}

    html += '</div>'; // close timeline
    html += '</div>'; // close phase
    return html;
  }

  /* POST-SESSION PHASE */
  function renderPostSession(r, mode){
    if(mode === 'none') return '';
    var phases = determinePhases(r);
    var phaseNum = (phases.pre==='none' && phases.inSession) ? '02' : '03';
    var html = '<div class="lw-his__phase">';
    html += '<div class="lw-his__phase-header"><div class="lw-his__phase-header-left">';
    html += '<span class="lw-his__phase-label">Phase '+phaseNum+'</span>';
    html += '<h2 class="lw-his__phase-title">Post-session</h2>';
    html += '</div><div class="lw-his__phase-meta">'+(mode==='full'?'First 2 hours':'First hour')+'</div></div>';
    if(mode === 'recovery-scaled' && r.transitionMode){
      var tm = r.transitionMode;
      html += '<p class="lw-his__phase-intro">You\'ll finish roughly '+tm.lossFluidMl+' ml of fluid and '+tm.lossSodiumMg+' mg of sodium down. In-session intake covers part of that — the rest is replaced here, where your gut can actually absorb it.</p>';
      html += '<div class="lw-his__timeline">';
      html += v4Row('Within 60 min', 'Replacement', v4Item('capsule', String(tm.recCaps), tm.recCaps === 1 ? 'capsule' : 'capsules') + v4Item('fluid', String(tm.recFluidMl), 'ml water'));
      html += v4Row('Next meal', 'Complete it', v4Item('fluid', 'Salt', 'your food') + v4Item('fluid', 'Fluid', 'to thirst'));
      html += '</div>';
      html += '</div>';
      return html;
    }
    if(mode === 'recovery-primary' && r.shortMode){
      var sm = r.shortMode;
      html += '<p class="lw-his__phase-intro"><strong>This is where replacement happens for a session this length.</strong> You\'ll finish roughly '+sm.lossFluidMl+' ml of fluid and '+sm.lossSodiumMg+' mg of sodium down. That deficit doesn\'t limit the session — but left unreplaced it compounds into the next one. Sodium retains the fluid; without it, water passes through and plasma volume doesn\'t restore.</p>';
      html += '<div class="lw-his__timeline">';
      html += v4Row('Within 60 min', 'Primary replacement', v4Item('capsule', String(sm.recCaps), sm.recCaps === 1 ? 'capsule' : 'capsules') + v4Item('fluid', String(sm.recFluidMl), 'ml water'));
      html += v4Row('Next meal', 'Complete it', v4Item('fluid', 'Salt', 'your food') + v4Item('fluid', 'Fluid', 'to thirst'));
      html += '</div>';
      html += '</div>';
      return html;
    }
    html += '<p class="lw-his__phase-intro">Recovery happens in the first hour. Replace fluid plus the sodium needed to retain it — without sodium, water passes through and plasma volume doesn\'t restore.</p>';
    html += '<div class="lw-his__timeline">';
    if(mode === 'full'){
      html += v4Row('Within 30 min', 'Immediate', v4Item('capsule', '2', 'capsules') + v4Item('fluid', '600', 'ml water'));
      html += v4Row('1 — 2 h post', 'With meal', v4Item('capsule', '1', 'capsule') + v4Item('fluid', '500', 'ml fluid'));
    } else {
      html += v4Row('Within 30 min', 'Immediate', v4Item('capsule', '1', 'capsule') + v4Item('fluid', '500', 'ml water'));
    }
    html += '</div>';
    html += '</div>';
    return html;
  }

  function renderProtocol(r){
    var phases = determinePhases(r);
    var html = '';
    if(r.sodiumValidationNote){
      html += '<div class="lw-his__guidance" style="margin:0 0 12px;"><div class="lw-his__guidance-label">Worth a sweat test</div><div class="lw-his__guidance-body">'+r.sodiumValidationNote.body+'</div></div>';
    }
    if(r.fluidCeilingNote){
      html += '<div class="lw-his__guidance" style="margin:0 0 12px;"><div class="lw-his__guidance-label">Fluid &amp; the long day</div><div class="lw-his__guidance-body">'+r.fluidCeilingNote.body+'</div></div>';
    }
    html += renderPreSession(r, phases.pre);
    html += renderInSession(r);
    html += renderPostSession(r, phases.post);
    var main = $('#lwProtocolMain');
    if(main) main.innerHTML = html;
  }

  /* INVENTORY — V4 structure */
  function renderInventory(r){
    var phases = determinePhases(r);
    var capsPre = 0, capsPost = 0;
    if(phases.pre === 'full') capsPre = 3;
    else if(phases.pre === 'reduced') capsPre = 2;
    else if(phases.pre === 'light') capsPre = 1;
    if(phases.post === 'full') capsPost = 3;
    else if(phases.post === 'single') capsPost = 1;
    else if(phases.post === 'recovery-primary') capsPost = (r.shortMode ? r.shortMode.recCaps : 1);
    else if(phases.post === 'recovery-scaled') capsPost = (r.transitionMode ? r.transitionMode.recCaps : 1);
    var capsIn = Math.ceil(r.totals.capsules);
    var capsTotal = capsPre + capsIn + capsPost;

    var fluidPre = (phases.pre === 'full') ? 1200 : (phases.pre === 'reduced' ? 650 : (phases.pre === 'light' ? 500 : 0));
    var fluidPost = (phases.post === 'full') ? 1100 : (phases.post === 'single' ? 500 : (phases.post === 'recovery-primary' ? (r.shortMode ? r.shortMode.recFluidMl : 500) : (phases.post === 'recovery-scaled' ? (r.transitionMode ? r.transitionMode.recFluidMl : 500) : 0)));
    var fluidTotal = r.totals.fluid + fluidPre + fluidPost;
    var fluidL = (fluidTotal / 1000).toFixed(1);

    var fluidLabel = (r.drinkLabel && r.drinkLabel !== 'water') ? r.drinkLabel + ' mix' : 'Fluid';
    var fluidSub = (r.drinkLabel && r.drinkLabel !== 'water') ? 'Mixed at label rate' : 'Pre + in + post';

    var html = '';
    html += '<div class="lw-his__inv-label">Inventory</div>';
    html += '<div class="lw-his__inv-headline">';
    html += '<div class="lw-his__inv-headline-item"><div class="lw-his__inv-headline-val">'+capsTotal+'</div><div class="lw-his__inv-headline-lbl">Capsules<small>Total for session</small></div></div>';
    html += '<div class="lw-his__inv-headline-item"><div class="lw-his__inv-headline-val">'+fluidL+' L</div><div class="lw-his__inv-headline-lbl">'+fluidLabel+'<small>'+fluidSub+'</small></div></div>';
    html += '<div class="lw-his__inv-headline-item"><div class="lw-his__inv-headline-val">'+r.totals.carbs+' g</div><div class="lw-his__inv-headline-lbl">Carbohydrate<small>'+(r.drinkLabel && r.drinkLabel!=='water' ? 'Incl. from drink' : 'In-session')+'</small></div></div>';
    html += '</div>';

    if(phases.pre !== 'none'){
      html += '<div class="lw-his__inv-phase">';
      html += '<div class="lw-his__inv-phase-title">Pre-session</div>';
      html += '<div class="lw-his__inv-row"><span>Capsules</span><span class="lw-his__inv-row-val">'+capsPre+'</span></div>';
      html += '<div class="lw-his__inv-row"><span>Fluid</span><span class="lw-his__inv-row-val">'+((fluidPre/1000).toFixed(1))+' L</span></div>';
      html += '</div>';
    }
    html += '<div class="lw-his__inv-phase">';
    html += '<div class="lw-his__inv-phase-title">In-session</div>';
    html += '<div class="lw-his__inv-row"><span>Capsules</span><span class="lw-his__inv-row-val">'+capsIn+'</span></div>';
    html += '<div class="lw-his__inv-row"><span>'+((r.drinkLabel && r.drinkLabel!=='water') ? r.drinkLabel : 'Fluid')+'</span><span class="lw-his__inv-row-val">'+((r.totals.fluid/1000).toFixed(1))+' L</span></div>';
    html += '<div class="lw-his__inv-row"><span>Carbs</span><span class="lw-his__inv-row-val">'+r.totals.carbs+' g</span></div>';
    html += '</div>';
    if(phases.post !== 'none'){
      html += '<div class="lw-his__inv-phase">';
      html += '<div class="lw-his__inv-phase-title">Post-session</div>';
      html += '<div class="lw-his__inv-row"><span>Capsules</span><span class="lw-his__inv-row-val">'+capsPost+'</span></div>';
      html += '<div class="lw-his__inv-row"><span>Fluid</span><span class="lw-his__inv-row-val">'+((fluidPost/1000).toFixed(1))+' L</span></div>';
      html += '</div>';
    }

    var inv = $('#lwProtocolInventory');
    if(inv) inv.innerHTML = html;
  }

  /* CALCULATIONS TAB (same logic as before, just dark-themed classes carry over) */
  function renderCalculations(r){
    var html = '';
    // Section 1
    html += '<div class="lw-his__calc-section">';
    html += '<div class="lw-his__calc-section-header"><div class="lw-his__calc-section-num">01</div><h3 class="lw-his__calc-section-title">Hydration</h3></div>';
    html += '<div class="lw-his__calc-grid">';
    html += '<div class="lw-his__calc-cell"><div class="lw-his__calc-cell-label">Sweat rate</div><div class="lw-his__calc-cell-val">'+r.sweatRate.toFixed(2)+' L/hr</div><div class="lw-his__calc-cell-sub">'+(state.sweatCustom ? 'from sweat test' : 'modeled')+'</div></div>';
    html += '<div class="lw-his__calc-cell"><div class="lw-his__calc-cell-label">Fluid replacement</div><div class="lw-his__calc-cell-val">'+r.fluidPerHr+' ml/hr</div><div class="lw-his__calc-cell-sub">~'+Math.round(getFluidReplacementPct()*100)+'% of sweat losses</div></div>';
    html += '</div>';
    html += '<p class="lw-his__calc-annot">Replacing 100% of sweat losses isn\'t the target — it overcommits the gut and risks GI distress. This model replaces roughly 55–70% depending on duration and fluid access, which is enough to limit body-mass loss without overcommitting the gut.</p>';
    if(r.fluidPerHr >= r.fluidCeiling){
      html += '<p class="lw-his__calc-annot" style="border-left:2px solid #ffd56b;padding-left:14px;margin-top:14px;"><strong>Fluid capped at the gut-absorption limit.</strong> Your modelled sweat rate of '+r.sweatRate.toFixed(2)+' L/hr would suggest more, but the gut absorbs only around '+r.fluidCeiling+' ml/hr during exercise at your body weight. Drinking past that pools in the stomach without hydrating you. Replace the rest by drinking to thirst before and after, not during. Over a long session, chasing full sweat replacement also raises dilutional risk if sodium intake lags.</p>';
    }
    html += '</div>';
    // Section 2
    html += '<div class="lw-his__calc-section">';
    html += '<div class="lw-his__calc-section-header"><div class="lw-his__calc-section-num">02</div><h3 class="lw-his__calc-section-title">Sodium</h3></div>';
    html += '<div class="lw-his__calc-grid">';
    html += '<div class="lw-his__calc-cell"><div class="lw-his__calc-cell-label">Sweat sodium</div><div class="lw-his__calc-cell-val">'+r.sodiumConc+' mg/L</div><div class="lw-his__calc-cell-sub">'+(state.sodiumCustom ? (state.sodiumCustomMode==='regional' ? 'sweat test, regional to whole-body' : 'sweat test, whole-body') : 'profile-derived')+'</div>'+(r.sodiumPop ? '<div class="lw-his__calc-cell-pop lw-his__calc-cell-pop--'+r.sodiumPop.band+'">'+r.sodiumPop.label+'</div>' : '')+'</div>';
    html += '<div class="lw-his__calc-cell"><div class="lw-his__calc-cell-label">Target intake</div><div class="lw-his__calc-cell-val">'+r.sodiumPerHr+' mg/hr</div><div class="lw-his__calc-cell-sub">~'+Math.round(r.replacementPct*100)+'% of losses</div></div>';
    html += '</div>';
    if(r.sodiumPop){
      html += '<p class="lw-his__calc-annot">Your '+(state.sodiumCustom ? 'measured' : 'estimated')+' sweat sodium ('+r.sodiumConc+' mg/L) is <strong>'+r.sodiumPop.label+'</strong> - '+r.sodiumPop.blurb+'. Whole-body values across 506 athletes averaged about 825 mg/L, ranging from roughly 420 to 1,630 mg/L (Baker et al., 2016). The figure above already includes the adjustment for your heat acclimation.'+(state.sodiumCustom ? '' : ' It is estimated from your profile; a measured sweat test pins it down.')+'</p>';
    }
    html += '<ul class="lw-his__calc-list">';
    html += '<li><strong>From your drink:</strong> '+r.drinkSodium+' mg/hr'+(r.drinkLabel?' ('+r.drinkLabel+')':'')+'</li>';
    if(r.shortMode){
      html += '<li><strong>In-session capsules:</strong> '+r.shortMode.inCaps+' — the session is too short for the deficit to limit performance mid-session</li>';
      html += '<li><strong>Deferred to recovery:</strong> '+r.shortMode.lossSodiumMg+' mg estimated total loss → <strong>'+r.shortMode.recCaps+' capsule'+(r.shortMode.recCaps===1?'':'s')+' with recovery fluid</strong></li>';
    } else {
      html += '<li><strong>Remaining from capsules:</strong> '+r.sodiumDeficit+' mg/hr → <strong>'+r.capsulesPerHr.toFixed(1)+' capsules per hour</strong></li>';
    }
    html += '</ul>';
    if(r.runSodiumNote){
      var rsn = r.runSodiumNote;
      var runBreakdown;
      if(rsn.runDrinkLabel){
        runBreakdown = (rsn.runGap > 0)
          ? 'your bike drink covers the bike, but the run is a separate leg. The run needs '+rsn.runSodiumNeed+' mg; '+rsn.runDrinkLabel+' on the run is counted at ~65% of its bike-leg rate ('+rsn.runCreditPerHr+' mg/hr, '+rsn.runCredit+' mg total) because cup intake is lower than bottle intake, leaving '+rsn.runGap+' mg covered by <strong>'+rsn.capsulesToCarry+' '+rsn.capsuleWord+'</strong> — counted in the inventory total.'
          : 'your bike drink covers the bike, and on the run '+rsn.runDrinkLabel+' counted at ~65% ('+rsn.runCreditPerHr+' mg/hr, '+rsn.runCredit+' mg total) already covers the run\'s '+rsn.runSodiumNeed+' mg. The <strong>'+rsn.capsulesToCarry+' '+rsn.capsuleWord+'</strong> shown is backup — still counted in the inventory total.';
      } else {
        runBreakdown = 'your drink covers the bike, but it won\'t be on the run course. The run\'s '+rsn.runSodiumNeed+' mg of sodium is replaced by <strong>'+rsn.capsulesToCarry+' '+rsn.capsuleWord+'</strong> carried for the run — counted in the inventory total.';
      }
      html += '<p class="lw-his__calc-annot" style="border-left:2px solid var(--p-mint);padding-left:14px;margin-top:14px;"><strong>Run leg — sodium carry:</strong> '+runBreakdown+'</p>';
    }
    html += '</div>';
    // Section 3 (v3.2.2: surface session-load gates alongside concentration band)
var bandLabel = ({ dilute:'Dilute', typical:'Typical', high:'High', 'very-high':'Very high', na:'N/A' })[r.concBand];
html += '<div class="lw-his__calc-section">';
html += '<div class="lw-his__calc-section-header"><div class="lw-his__calc-section-num">03</div><h3 class="lw-his__calc-section-title">Plan check</h3></div>';
html += '<p class="lw-his__calc-annot"><strong>Plan concentration:</strong> <span class="lw-his__calc-band lw-his__calc-band--'+r.concBand+'">'+bandLabel+'</span></p>';

if(r.shortMode){
  html += '<p class="lw-his__calc-annot">Short-session protocol applied. In-session concentration matters less here — the plan moves replacement to the recovery window, where sodium dose can be matched to the measured deficit without mid-session gut load.</p>';
} else if(r.concBand === 'high' || r.concBand === 'very-high'){
  html += '<p class="lw-his__calc-annot">This is the precise use case for the capsule format. Hitting your sodium target via drinks alone at this concentration would mean either over-drinking or under-dosing.</p>';
} else if(r.concBand === 'dilute'){
  html += '<p class="lw-his__calc-annot">Your fluid plan is well above your sodium target — common in cool conditions. Capsules close the small gap without forcing you to over-concentrate your drink.</p>';
} else {
  html += '<p class="lw-his__calc-annot">A typical concentration on a per-litre basis. Capsules give you the precision your drink lacks — adjustable for heat changes mid-session.</p>';
}

// Cross-reference any session-load gates that fired
if(r.gates && r.gates.length > 0){
  var nonConcGates = r.gates.filter(function(g){ return g.type !== 'concentration'; });
  if(nonConcGates.length > 0){
    var gateList = nonConcGates.map(function(g){ return g.label.toLowerCase(); }).join(', ');
    html += '<p class="lw-his__calc-annot" style="border-left:2px solid #ffd56b;padding-left:14px;margin-top:18px;">';
    html += '<strong>Session-load advisories:</strong> while concentration is within typical ranges, this plan also flagged ' + gateList + '. ';
    html += 'See the protocol tab for full advisory detail.</p>';
  }
}

if(r.assumptions.length){
  html += '<p class="lw-his__calc-annot"><strong>Assumptions applied:</strong> '+r.assumptions.join(' · ')+'.</p>';
}
html += '<p class="lw-his__calc-annot"><strong>Confidence:</strong> '+r.confidence+'%. Sweat test data and recent race-condition training improve confidence most.</p>';
/* v3.40: intake is not utilisation. Gastric emptying rates vary widely between
   people, and the body holds exchangeable sodium stores, so what is swallowed
   is not necessarily what reaches the blood on the same timescale. */
html += '<p class="lw-his__calc-annot"><strong>What these numbers are:</strong> targets for what to <em>take in</em>, not a measurement of what your body will use. Gastric emptying differs substantially between people, and sodium can be stored and mobilised rather than used immediately. Treat the plan as a carrying and timing guide, and adjust it against how you actually respond.</p>';
html += '</div>';
    var c = $('#lwProtocolCalcContent');
    if(c) c.innerHTML = html;
  }

  function renderUnsafeInterrupt(r){
  var el = $('#lwUnsafeInterrupt');
  if(!el) return;
  if(!r.gates || r.gates.length === 0){
    el.style.display = 'none';
    el.innerHTML = '';
    return;
  }

  var gateCount = r.gates.length;
  var titleText, leadText;
  if(gateCount === 1){
    titleText = r.gates[0].label + '.';
    leadText = 'This plan triggered one check worth reviewing before you rely on it for a key session.';
  } else {
    titleText = 'This plan triggered ' + gateCount + ' checks worth reviewing.';
    leadText = 'High-load plans aren\'t inherently wrong — but they require execution discipline and benefit from validation before key sessions.';
  }

  var html = '<div class="lw-his__unsafe">';
  html += '<div class="lw-his__unsafe-label">Advisory — Review before use</div>';
  html += '<h3 class="lw-his__unsafe-title">' + titleText + '</h3>';
  html += '<p class="lw-his__unsafe-body">' + leadText + '</p>';

  html += '<ul class="lw-his__unsafe-checklist">';
  r.gates.forEach(function(g){
    html += '<li><strong style="color:var(--p-base);display:block;margin-bottom:4px;">' + g.label + '</strong>' + g.body + '</li>';
  });
  html += '</ul>';

  html += '<p class="lw-his__unsafe-body" style="font-size:0.88rem;opacity:0.78;margin-top:18px;">' +
          'Validate against a sweat sodium test, race history, or sports-medicine input before relying on this protocol. ' +
          'Lytework\'s Hydration Intelligence System is an experimental decision-support tool — not medical advice.' +
          '</p>';

  html += '<div class="lw-his__unsafe-actions">';
  html += '<button class="lw-his__unsafe-btn" data-back="3">Review inputs</button>';
  html += '<button class="lw-his__unsafe-btn lw-his__unsafe-btn--primary" id="lwAckProtocol">I understand — show protocol</button>';
  html += '</div>';
  html += '</div>';

  el.innerHTML = html;
  el.style.display = 'block';

  var backBtn = el.querySelector('[data-back]');
  if(backBtn) backBtn.addEventListener('click', function(){ goToStep(3); });
  var ackBtn = el.querySelector('#lwAckProtocol');
  if(ackBtn) ackBtn.addEventListener('click', acknowledgeAdvisory);
}

  function acknowledgeAdvisory(){
  var advisory = $('#lwUnsafeInterrupt');
  if(advisory) advisory.style.display = 'none';
  var banner = $('#lwAckBanner');
  var bannerList = $('#lwAckBannerList');
  if(banner){
    banner.classList.add('is-active');
    if(bannerList && state.results && state.results.gates){
      bannerList.innerHTML = buildGatesInPageHtml(state.results.gates);
    }
  }
  var gate = $('#lwGate');
  var gated = $('#lwGatedResults');
  // Treat a previously-saved email as unlocked too — not just this-session unlock.
  // Without this, acknowledging after an edit could leave the email gate showing
  // while a stale is-unlocked class let the results render underneath it.
  var unlocked = state.emailUnlocked;
  try { if(localStorage.getItem('lw_email')) unlocked = true; } catch(e){}
  if(unlocked){
    if(gate){ gate.classList.add('is-unlocked'); gate.style.display = ''; }
    if(gated){
      gated.classList.add('is-unlocked');
      gated.style.display = 'block';
    }
  } else {
    // Locked: show the email gate and force the results hidden (clear any leftover
    // is-unlocked) so the two are always mutually exclusive.
    if(gate){ gate.classList.remove('is-unlocked'); gate.style.display = 'block'; }
    if(gated){ gated.classList.remove('is-unlocked'); gated.style.display = 'none'; }
  }
  setTimeout(function(){
    var target = unlocked ? gated : gate;
    if(target){
      var rect = target.getBoundingClientRect();
      window.scrollTo({ top: window.pageYOffset + rect.top - 90, behavior: 'smooth' });
    }
  }, 50);
}


  /* MAIN RESULTS RENDER */
  function renderResults(r){
    /* v3.38: title matches the session — the page previously said
       "Race-day briefing." for training sessions (the email already
       branched on session_type; the page h1 was hardcoded). */
    var titleEl = $('#lwResultsTitle');
    if(titleEl) titleEl.textContent = state.sessionType === 'race' ? 'Race-day briefing.' : 'Session briefing.';
    // Summary
    var sumEl = $('#lwProtocolSummary');
    if(sumEl) sumEl.innerHTML = buildSummary(r);

    // Confidence label
    var confEl = $('#lwProtocolConfidenceLabel');
    if(confEl){
      var label = r.confidence >= 90 ? 'High confidence' : (r.confidence >= 75 ? 'Good confidence' : 'Moderate confidence');
      confEl.textContent = label + ' · ' + r.confidence + '%';
    }

    // Drink covers callout (scenario 4)
    var covered = $('#lwProtocolCovered');
    if(covered){
      if(r.drinkCovers && r.drinkLabel){
        var body;
        if(r.runSodiumNote){
          if(r.runSodiumNote.runDrinkLabel){
            body = (r.runSodiumNote.runGap > 0)
              ? '<strong>'+r.drinkLabel+'</strong> delivers '+r.drinkSodium+' mg/hr — at or above your target of '+r.sodiumPerHr+' mg/hr, so the <strong>bike runs on the drink</strong>. The run is different: you\'ll be on <strong>'+r.runSodiumNote.runDrinkLabel+'</strong> (counted at ~65% for cup intake), so top up the gap with <strong>'+r.runSodiumNote.capsulesToCarry+' '+r.runSodiumNote.capsuleWord+'</strong> (see the run leg below).'
              : '<strong>'+r.drinkLabel+'</strong> delivers '+r.drinkSodium+' mg/hr — at or above your target of '+r.sodiumPerHr+' mg/hr, so the <strong>bike runs on the drink</strong>. On the run you\'ll be on <strong>'+r.runSodiumNote.runDrinkLabel+'</strong>, which covers the run too — carry <strong>'+r.runSodiumNote.capsulesToCarry+' '+r.runSodiumNote.capsuleWord+'</strong> as backup (see the run leg below).';
          } else {
            body = '<strong>'+r.drinkLabel+'</strong> delivers '+r.drinkSodium+' mg/hr — at or above your target of '+r.sodiumPerHr+' mg/hr, so the <strong>bike runs on the drink</strong>. The run is different: aid stations won\'t have it, so your run sodium is carried as <strong>'+r.runSodiumNote.capsulesToCarry+' '+r.runSodiumNote.capsuleWord+'</strong> (see the run leg below).';
          }
        } else {
          body = '<strong>'+r.drinkLabel+'</strong> already delivers '+r.drinkSodium+' mg/hr — at or above your target of '+r.sodiumPerHr+' mg/hr. No capsules needed for sodium replacement. The protocol below focuses on hourly hydration cadence and timing.';
        }
        var bodyEl = $('#lwProtocolCoveredBody');
        if(bodyEl) bodyEl.innerHTML = body;
        covered.style.display = 'block';
      } else {
        covered.style.display = 'none';
      }
    }

    // Gates / advisories
renderUnsafeInterrupt(r);

// If any gates fired, hide gate and gated content until user acknowledges
if(r.gates && r.gates.length > 0){
  var gate = $('#lwGate'); if(gate) gate.style.display = 'none';
  var gated = $('#lwGatedResults'); if(gated) gated.style.display = 'none';
  renderProtocol(r);
  renderInventory(r);
  renderCalculations(r);
  lwRenderSeeCapsules(r);
  return;
}

    // Build gate description
    var gateDesc = $('#lwGateDesc');
    if(gateDesc){
      if(state.sessionType === 'race'){
        gateDesc.innerHTML = 'We\'ll send your complete hydration and fuelling plan to your inbox — pre-session loading, hour-by-hour execution, post-session recovery.';
      } else {
        gateDesc.innerHTML = 'We\'ll send your complete hydration and fuelling plan to your inbox — hour-by-hour execution with cadence guidance.';
      }
    }

    // Sport-specific gate bullet
    var sportBullet = $('#lwGateBulletSport');
    var sportText = $('#lwGateBulletSportText');
    if(sportBullet && sportText){
      if(state.sport === 'triathlon'){
        sportText.textContent = 'Triathlon-specific swim / bike / run breakdown';
        sportBullet.style.display = 'list-item';
      } else {
        sportBullet.style.display = 'none';
      }
    }

    // Render all three views
    renderProtocol(r);
    renderInventory(r);
    renderCalculations(r);
    lwRenderSeeCapsules(r);

    // If already unlocked, show
    if(state.emailUnlocked){
      var gate2 = $('#lwGate'); if(gate2) gate2.classList.add('is-unlocked');
      var gated2 = $('#lwGatedResults'); if(gated2) gated2.classList.add('is-unlocked');
    }
  }

  /* ════════════════════════════════════════════════════════
     WEBHOOK & EMAIL
  ════════════════════════════════════════════════════════ */
  function buildPayload(r){
    /* v3.4: payload structure matches the Google Sheets column schema set up
       by Flowmondo. Field names use the original physiology_*, environment_*,
       sweatProfile_*, session_*, outputs_*, emailSummary_*, triathlon_*
       prefix convention. */

    // ─── Helper: weight in kg ─────────────────────
    var weightKg = state.weight;
    if(state.weight && state.weightUnit === 'lbs'){
      weightKg = Math.round(state.weight * 0.453592 * 10) / 10;
    }
    /* v3.39: when weight was never entered the engine estimates 70 kg (and the
       confidence line discloses it), but the email's PROFILE INPUTS row mapped
       the raw field and rendered "Body weight    kg" — a labelled row with no
       value, which reads as broken. weightDisplay carries what the row should
       actually say; the numeric field stays untouched for Sheets analysis. */
    var weightDisplay = weightKg ? String(weightKg) : '~70 (estimated)';

    // ─── Sweat profile mode ───────────────────────
    var sweatMode = (state.sweatCustom || state.sodiumCustom) ? 'custom' : 'preset';

    // ─── Capsule timing string (v3.3) ─────────────
// Cadence is driven by the whole-capsule total spaced across the session,
// never a fixed phrase keyed to the per-hour rate. A sub-1/hr rate must not
// print "1 capsule per hour" — that implies one per clock hour.
var cphr = (r && r.capsulesPerHr != null) ? r.capsulesPerHr : 0;
var capsTotalForCadence = (r && r.totals) ? Math.ceil(r.totals.capsules) : 0;

// Whole-number capsule split per leg — mirrors the in-page triathlon timeline:
// none on the swim, bike rounded from the rate, run takes the remainder.
var triBikeCaps = 0, triRunCaps = 0;
if(state.sport === 'triathlon' && capsTotalForCadence > 0){
  triBikeCaps = Math.round(cphr * state.triBike);
  if(triBikeCaps > capsTotalForCadence) triBikeCaps = capsTotalForCadence;
  if(triBikeCaps < 0) triBikeCaps = 0;
  triRunCaps = capsTotalForCadence - triBikeCaps;
  if(triRunCaps < 0) triRunCaps = 0;
}

var capTiming = '';
if(r && r.shortMode){
  capTiming = r.shortMode.inCaps > 0
    ? 'one capsule mid-session with fluid (' + r.shortMode.reason + ') — remaining replacement with recovery fluids after'
    : 'none during the session — this duration doesn\'t require intra-session sodium; replacement happens in recovery';
} else if(capsTotalForCadence <= 0){
  capTiming = 'no capsules needed — your drink covers the sodium target';
} else if(state.sport === 'triathlon'){
  var triCadParts = [];
  if(triBikeCaps > 0) triCadParts.push(triBikeCaps + ' across the bike');
  if(triRunCaps > 0) triCadParts.push(triRunCaps + ' across the run');
  capTiming = triCadParts.length
    ? 'none on the swim — ' + triCadParts.join(' and ') + ', spaced evenly and taken with fluid'
    : 'no capsules needed during the legs — your drink covers the sodium target';
} else if(cphr >= 1){
  if(cphr <= 1.15){
    capTiming = 'one per hour, taken mid-hour with fluid';
  } else {
    var ivHi = Math.round(60 / cphr / 5) * 5;
    if(ivHi < 10) ivHi = 10;
    capTiming = 'one every ' + ivHi + ' min, spaced evenly — don\'t front-load';
  }
} else {
  // Sparse (< 1 capsule/hr): name the even centroid times so the email
  // matches where the in-page timeline actually drops each capsule.
  var N = capsTotalForCadence;
  var durTotal = state.durationMin;
  var centroidAt = function(k){ return Math.round(((k - 0.5) / N * durTotal) / 5) * 5; };
  if(N === 1){
    capTiming = 'taken around ' + durStrShort(centroidAt(1)) + ' in, with fluid';
  } else if(N === 2){
    capTiming = 'one around ' + durStrShort(centroidAt(1)) +
                ', the second around ' + durStrShort(centroidAt(2)) + ' — both with fluid';
  } else {
    var gapMin = Math.round((durTotal / N) / 5) * 5;
    var gapLabel;
    if(gapMin >= 90){
      var gapHr = Math.round((gapMin / 60) * 2) / 2;
      gapLabel = (gapHr % 1 === 0 ? gapHr.toFixed(0) : gapHr) + ' h';
    } else {
      gapLabel = gapMin + ' min';
    }
    capTiming = 'starting around ' + durStrShort(centroidAt(1)) +
                ' in, then roughly every ' + gapLabel + ' — with fluid';
  }
}

    // ─── Email summary strings ────────────────────
    var sportLabels = { run:'Run', cycle:'Cycle', swim:'Swim', triathlon:'Triathlon', other:'Endurance' };
    var sportLabel = sportLabels[state.sport] || 'Session';
    var triFormatLabels = { sprint:'Sprint', olympic:'Olympic', half:'70.3', full:'140.6' };
    var triFormatLabel = state.sport === 'triathlon' ? (triFormatLabels[state.triFormat] || '') : '';
    var typeLabel = state.sessionType === 'race' ? 'race' : 'training session';
    var durFormatted = durStr(state.durationMin);
    var tempDisplay = state.tempC + '°C';

    var headline = 'Your hydration strategy is ready.';
    var subline = durFormatted + ' ' + sportLabel +
                  (triFormatLabel ? ' (' + triFormatLabel + ')' : '') +
                  ' ' + typeLabel + ' in ' + tempDisplay + '.';
    var fluidStatement = (r && r.fluidPerHr != null)
      ? r.fluidPerHr + ' ml per hour — ' + (r && r.totals ? r.totals.fluid : 0) + ' ml total.'
      : '';
    var sodiumStatement = (r && r.sodiumPerHr != null)
      ? r.sodiumPerHr + ' mg per hour — ' + (r && r.totals ? r.totals.sodium : 0) + ' mg total.'
      : '';
    // Short mode (v3.22): the target is not an intake instruction — say where
    // the sodium actually goes so "500 mg per hour" never sits next to "0
    // capsules during" unexplained.
    // Transition band with a capped in-session rate (v3.27): the per-hour
    // figure is the TARGET and the total is actual INTAKE, so stating them as
    // "X per hour — Y total" reads as broken arithmetic. Say what each is.
    if(r && r.transitionMode && r.transitionMode.capped && r.sodiumPerHr != null){
      sodiumStatement = r.sodiumPerHr + ' mg/hr target — ' + (r.totals ? r.totals.sodium : 0) +
        ' mg of that taken during the session, the balance replaced in recovery.';
    }
    if(r && r.shortMode && r.sodiumPerHr != null){
      sodiumStatement = (r.drinkSodium > 0)
        ? r.sodiumPerHr + ' mg target — ' + r.drinkSodium + ' mg/hr comes from your drink during; the rest is replaced in recovery, not mid-session.'
        : r.sodiumPerHr + ' mg target — replaced in recovery rather than during. This duration doesn\'t need it mid-session.';
    }
    var carbStatement = (r && r.carbsPerHr != null)
      ? r.carbsPerHr + ' g carbohydrate per hour — ' + (r && r.totals ? r.totals.carbs : 0) + ' g total.'
      : '';
    // Short mode with zero carbs (v3.22): a bare "0 g" reads as a fault, not a
    // recommendation — explain it. Short sessions at higher intensity keep the
    // standard numeric statement.
    if(r && r.shortMode && r.carbsPerHr === 0){
      carbStatement = 'No carbohydrate needed during a session this length — fuel normally beforehand and it\'s covered.';
    }
    var capsTotal = (r && r.totals) ? Math.ceil(r.totals.capsules) : 0;
    var capsuleStatement;
if(r && r.shortMode){
  var smRec = r.shortMode.recCaps;
  capsuleStatement = r.shortMode.inCaps > 0
    ? '1 Lytework capsule during the session (' + r.shortMode.reason + ') — then ' + smRec + ' with recovery fluids within the hour after.'
    : '0 Lytework capsules during the session — ' + smRec + ' with recovery fluids within the hour after. This duration doesn\'t require intra-session sodium.'
} else if(capsTotal <= 0){
  capsuleStatement = 'No capsules required — your drink covers the sodium target.';
} else {
  capsuleStatement = capsTotal + ' Lytework capsule' + (capsTotal === 1 ? '' : 's') +
    ' across the session — ' + capTiming + '.';
}

// Recovery statement (v3.21): populated in short mode so the email can lead
// with the replacement story; empty string otherwise (Make gates on it).
var recoveryStatement = '';
if(r && r.transitionMode){
  var tmr = r.transitionMode;
  recoveryStatement = 'You\'ll finish roughly ' + tmr.lossFluidMl + ' ml of fluid and ' +
    tmr.lossSodiumMg + ' mg of sodium down, and in-session intake covers part of that. ' +
    'Within the hour after: ' + tmr.recCaps + ' capsule' + (tmr.recCaps === 1 ? '' : 's') + ' with ' +
    tmr.recFluidMl + ' ml of water, then salt your next meal.';
}
if(r && r.shortMode){
  recoveryStatement = 'You\'ll finish roughly ' + r.shortMode.lossFluidMl + ' ml of fluid and ' +
    r.shortMode.lossSodiumMg + ' mg of sodium down. Within the hour after: ' +
    r.shortMode.recCaps + ' capsule' + (r.shortMode.recCaps === 1 ? '' : 's') + ' with ' +
    r.shortMode.recFluidMl + ' ml of water, then salt your next meal. ' +
    'The deficit doesn\'t limit this session — left unreplaced, it compounds into the next one.';
}

// Full-session capsule inventory (mirrors the in-page inventory "Total for session"):
// pre-load + in-session + recovery. Surfaced so the email's CAPSULE SUPPLY line can
// match what the calculator page shows, not just the in-session count.
var invPhases = determinePhases(r);
var invCapsPre = invPhases.pre === 'full' ? 3 : (invPhases.pre === 'reduced' ? 2 : (invPhases.pre === 'light' ? 1 : 0));
var invCapsPost = invPhases.post === 'full' ? 3 : (invPhases.post === 'single' ? 1 : (invPhases.post === 'recovery-primary' ? ((r && r.shortMode) ? r.shortMode.recCaps : 1) : (invPhases.post === 'recovery-scaled' ? ((r && r.transitionMode) ? r.transitionMode.recCaps : 1) : 0)));
var invCapsTotal = invCapsPre + capsTotal + invCapsPost;

    var drinkNote = '';
    if(r && r.shortMode){
      // v3.22: name the athlete's actual drink — the previous wording assumed
      // plain water even when a product was selected.
      var smDrinkLabel = null;
      if(state.drinkSetup === 'picker' && state.drinkProduct && PRODUCT_PRESETS[state.drinkProduct]){
        smDrinkLabel = PRODUCT_PRESETS[state.drinkProduct].label;
      } else if(state.drinkSetup === 'custom'){
        smDrinkLabel = 'Your usual drink';
      }
      var smDrinkLead = smDrinkLabel ? smDrinkLabel + ' to thirst' : 'Plain water to thirst';
      drinkNote = r.shortMode.inCaps > 0
        ? smDrinkLead + ' + 1 capsule — sodium replacement completes in recovery.'
        : smDrinkLead + ' — no in-session sodium required at this duration. Replacement happens in recovery.';
    } else if(state.drinkSetup === 'water'){
      drinkNote = (r && r.transitionMode && r.transitionMode.capped)
        ? 'Plain water + Lytework capsules — capsules carry your in-session sodium; the balance is covered by the pre-load and recovery blocks.'
        : 'Plain water + Lytework capsules — capsules cover 100% of sodium target.';
    } else if(state.drinkSetup === 'picker' && state.drinkProduct && PRODUCT_PRESETS[state.drinkProduct]){
      var prod = PRODUCT_PRESETS[state.drinkProduct];
      drinkNote = capsTotal > 0
        ? prod.label + ' delivers ~' + prod.sodium + ' mg sodium/hr — capsules close the remaining gap.'
        : prod.label + ' delivers ~' + prod.sodium + ' mg sodium/hr — that covers your full sodium target.';
    } else if(state.drinkSetup === 'custom'){
      drinkNote = capsTotal > 0
        ? 'Custom drink delivers ' + (state.drinkSodiumMg || 0) + ' mg sodium/hr — capsules close the remaining gap.'
        : 'Custom drink delivers ' + (state.drinkSodiumMg || 0) + ' mg sodium/hr — that covers your full sodium target.';
    }

    // ─── Assumptions ──────────────────────────────
    var assumptionsArr = (r && r.assumptions) ? r.assumptions : [];
    var assumptionsStr = assumptionsArr.join(' · ');

    // ─── Sodium loss raw (pre-target adjustment) ──
    var sweatRateNum = (r && r.sweatRate != null) ? r.sweatRate : 0;
    var sodiumConcNum = (r && r.sodiumConc != null) ? r.sodiumConc : 0;
    var sodiumLossRaw = Math.round(sweatRateNum * sodiumConcNum);

    // ─── Fluid gut-cap flag ───────────────────────
    var fluidGutCapped = (r && r.fluidPerHr != null && r.fluidCeiling != null)
      ? (r.fluidPerHr >= r.fluidCeiling)
      : false;

    // ─── Triathlon breakdown ──────────────────────
    var isTri = state.sport === 'triathlon';
    var triBD = (r && r.triBreakdown) ? r.triBreakdown : null;

    function triSegment(seg, fallbackNote){
      if(!triBD || !triBD[seg]){
        return {
          durationMin: 0, fluidMl: 0, sodiumTargetMg: 0, carbsG: 0,
          capsulesPerHr: 0, capsulesTotalForSegment: 0,
          sodiumFromDrinkMg: 0, sodiumRemainingMg: 0,
          note: fallbackNote || ''
        };
      }
      var s = triBD[seg];
      var durMin = Math.round(s.duration * 60);
      var drinkSodSeg = Math.round((r.drinkSodium || 0) * s.duration);
      var sodRemain = Math.max(0, s.sodium - drinkSodSeg);
      var capsTotalSeg = Math.round(s.capsules * 10) / 10;
      return {
        durationMin: durMin,
        fluidMl: s.fluid,
        sodiumTargetMg: s.sodium,
        carbsG: s.carbs,
        capsulesPerHr: (r.capsulesPerHr != null ? r.capsulesPerHr : 0),
        capsulesTotalForSegment: capsTotalSeg,
        sodiumFromDrinkMg: drinkSodSeg,
        sodiumRemainingMg: sodRemain,
        note: s.note || ''
      };
    }
    var triSwim = triSegment('swim', 'No intake during swim');
    var triBike = triSegment('bike', '');
    var triRun = triSegment('run', '');
    // Per-leg capsule counts use the whole-number split so bike + run reconcile
    // to the session total (rather than fractional values that don't add up).
    if(isTri){
      triSwim.capsulesTotalForSegment = 0;
      triBike.capsulesTotalForSegment = triBikeCaps;
      triRun.capsulesTotalForSegment = triRunCaps;
      // Run drink (if any) credited at the discounted run-intake rate; remainder is the capsule gap.
      if(r && r.runSodiumNote){
        triRun.sodiumFromDrinkMg = r.runSodiumNote.runCredit || 0;
        triRun.sodiumRemainingMg = (r.runSodiumNote.runGap != null) ? r.runSodiumNote.runGap : triRun.sodiumRemainingMg;
      }
    }

    return {
      /* ─── Metadata ─────────────────────────────── */
      timestamp: new Date().toISOString(),
      email: state.email || '',
      version: '3.40',
      capsuleSodiumMg: CAPSULE_NA,

      /* ─── Short-session mode (v3.21) ───────────── */
      session_shortMode: (r && r.shortMode) ? 'yes' : 'no',
      session_transitionMode: (r && r.transitionMode) ? 'yes' : 'no',
      sodium_targetCapped: (r && r.sodiumCapped) ? 'yes' : 'no',
      sodium_targetUncappedMg: (r && r.sodiumUncapped != null) ? r.sodiumUncapped : 0,
      session_inSessionCapped: (r && r.transitionMode && r.transitionMode.capped) ? 'yes' : 'no',
      session_shortModeInSessionCapsules: (r && r.shortMode) ? r.shortMode.inCaps : 0,
      session_shortModeReason: (r && r.shortMode) ? (r.shortMode.reason || '') : '',
      recovery_capsules: (r && r.shortMode) ? r.shortMode.recCaps : ((r && r.transitionMode) ? r.transitionMode.recCaps : 0),
      recovery_fluidMl: (r && r.shortMode) ? r.shortMode.recFluidMl : ((r && r.transitionMode) ? r.transitionMode.recFluidMl : 0),
      recovery_sodiumLossTotalMg: (r && r.shortMode) ? r.shortMode.lossSodiumMg : ((r && r.transitionMode) ? r.transitionMode.lossSodiumMg : 0),
      recovery_fluidLossTotalMl: (r && r.shortMode) ? r.shortMode.lossFluidMl : ((r && r.transitionMode) ? r.transitionMode.lossFluidMl : 0),
      emailSummary_recoveryStatement: recoveryStatement,

      /* ─── Physiology (Flowmondo schema) ─────────── */
      physiology_weightKg: weightKg,
      physiology_weightDisplay: weightDisplay,
      physiology_experience: state.experience || '',
      physiology_gutSensitivity: state.gutSensitivity || '',
      physiology_heatAcclimation: state.heatAcclim || '',

      /* ─── Environment ──────────────────────────── */
      environment_temperatureC: state.tempC,
      environment_humidity: state.humidity || '',
      environment_setting: state.setting || '',
      environment_sunExposure: state.sun || '',

      /* ─── Sweat profile ────────────────────────── */
      sweatProfile_mode: sweatMode,
      sweatProfile_sweatPreset: state.sweatPreset || '',
      sweatProfile_sodiumPreset: state.sodiumPreset || '',
      sweatProfile_customSweatRate: state.sweatCustom || '',
      sweatProfile_customSodiumConc: state.sodiumCustom || '',
      sweatProfile_customSodiumMode: state.sodiumCustom ? state.sodiumCustomMode : '',
      sweatProfile_customSodiumWholeBody: effectiveSodiumCustom() || '',
      sweatProfile_effectiveSweatRateLPerHr: sweatRateNum,
      sweatProfile_effectiveSodiumConcMgPerL: sodiumConcNum,
      sweatProfile_sodiumPopBand: (r && r.sodiumPop) ? r.sodiumPop.band : '',
      sweatProfile_sodiumPopLabel: (r && r.sodiumPop) ? r.sodiumPop.label : '',

      /* ─── Session ──────────────────────────────── */
      session_type: state.sessionType || '',
      session_sport: state.sport || '',
      session_triFormat: state.triFormat || '',
      session_durationMin: state.durationMin,
      session_durationFormatted: durFormatted,
      session_intensity: state.intensity || '',
      session_aidStationAccess: state.aidStation || '',
      session_drinkSetup: state.drinkSetup || '',
      session_drinkSodiumMgHr: (r && r.drinkSodium != null) ? r.drinkSodium : 0,

      /* ─── Hourly outputs ───────────────────────── */
      outputs_hourly_fluidMl: (r && r.fluidPerHr != null) ? r.fluidPerHr : 0,
      outputs_hourly_fluidCappedByGut: fluidGutCapped,
      outputs_hourly_sodiumLossMg: sodiumLossRaw,
      outputs_hourly_sodiumTargetMg: (r && r.sodiumPerHr != null) ? r.sodiumPerHr : 0,
      outputs_hourly_sodiumFromDrinkMg: (r && r.drinkSodium != null) ? r.drinkSodium : 0,
      outputs_hourly_sodiumRemainingMg: (r && r.sodiumDeficit != null) ? r.sodiumDeficit : 0,
      outputs_hourly_carbsG: (r && r.carbsPerHr != null) ? r.carbsPerHr : 0,
      outputs_hourly_capsulesPerHr: cphr,

      /* ─── Total outputs ────────────────────────── */
      outputs_totals_fluidMl: (r && r.totals) ? r.totals.fluid : 0,
      outputs_totals_sodiumMg: (r && r.totals) ? r.totals.sodium : 0,
      outputs_totals_carbsG: (r && r.totals) ? r.totals.carbs : 0,
      outputs_totals_capsules: capsTotal,
      inventory_capsules_pre: invCapsPre,
      inventory_capsules_in: capsTotal,
      inventory_capsules_post: invCapsPost,
      inventory_capsules_total: invCapsTotal,
      outputs_capsuleTiming: capTiming,
      outputs_confidence: (r && r.confidence != null) ? r.confidence : '',

      /* ─── Email summary lines ──────────────────── */
      emailSummary_headline: headline,
      emailSummary_subline: subline,
      emailSummary_fluidStatement: fluidStatement,
      emailSummary_sodiumStatement: sodiumStatement,
      emailSummary_carbStatement: carbStatement,
      emailSummary_capsuleStatement: capsuleStatement,
      emailSummary_drinkSetupNote: drinkNote,

      /* ─── Meta ─────────────────────────────────── */
      assumptions: assumptionsStr,
      triathlonBreakdown: isTri ? 'yes' : 'no',

      /* ─── Triathlon swim segment ───────────────── */
      triathlon_swim_durationMin: triSwim.durationMin,
      triathlon_swim_fluidMl: triSwim.fluidMl,
      triathlon_swim_sodiumTargetMg: triSwim.sodiumTargetMg,
      triathlon_swim_carbsG: triSwim.carbsG,
      triathlon_swim_capsulesPerHr: triSwim.capsulesPerHr,
      triathlon_swim_capsulesTotalForSegment: triSwim.capsulesTotalForSegment,
      triathlon_swim_sodiumFromDrinkMg: triSwim.sodiumFromDrinkMg,
      triathlon_swim_sodiumRemainingMg: triSwim.sodiumRemainingMg,
      triathlon_swim_note: triSwim.note,

      /* ─── Triathlon bike segment ───────────────── */
      triathlon_bike_durationMin: triBike.durationMin,
      triathlon_bike_fluidMl: triBike.fluidMl,
      triathlon_bike_sodiumTargetMg: triBike.sodiumTargetMg,
      triathlon_bike_carbsG: triBike.carbsG,
      triathlon_bike_capsulesPerHr: triBike.capsulesPerHr,
      triathlon_bike_capsulesTotalForSegment: triBike.capsulesTotalForSegment,
      triathlon_bike_sodiumFromDrinkMg: triBike.sodiumFromDrinkMg,
      triathlon_bike_sodiumRemainingMg: triBike.sodiumRemainingMg,
      triathlon_bike_note: triBike.note,

      /* ─── Triathlon run segment ────────────────── */
      triathlon_run_durationMin: triRun.durationMin,
      triathlon_run_fluidMl: triRun.fluidMl,
      triathlon_run_sodiumTargetMg: triRun.sodiumTargetMg,
      triathlon_run_carbsG: triRun.carbsG,
      triathlon_run_capsulesPerHr: triRun.capsulesPerHr,
      triathlon_run_capsulesTotalForSegment: triRun.capsulesTotalForSegment,
      triathlon_run_sodiumFromDrinkMg: triRun.sodiumFromDrinkMg,
      triathlon_run_sodiumRemainingMg: triRun.sodiumRemainingMg,
      triathlon_run_note: triRun.note,

      /* ─── Gates / advisories (v3.1) ────────────── */
gates_fired_count: (r && r.gates) ? r.gates.length : 0,
gates_fired_types: (r && r.gates) ? r.gates.map(function(g){ return g.type; }).join(',') : '',
gates_fired_labels: (r && r.gates) ? r.gates.map(function(g){ return g.label; }).join(' | ') : '',
gates_email_block_html: (r && r.gates) ? buildGatesEmailHtml(r.gates) : '',
gates_acknowledged_at: (r && r.gates && r.gates.length > 0) ? new Date().toISOString() : '',
/* ─── Run-leg sodium gap note (v3.2) ───────── */
run_sodium_note_html: (r && r.runSodiumNote) ? buildRunSodiumNoteEmailHtml(r.runSodiumNote) : '',
run_sodium_note_capsules: (r && r.runSodiumNote) ? r.runSodiumNote.capsulesToCarry : 0,
run_sodium_note_fired: (r && r.runSodiumNote) ? 'yes' : 'no',
run_sodium_note_gap: (r && r.runSodiumNote && r.runSodiumNote.runGap != null) ? r.runSodiumNote.runGap : 0,
run_drink_label: (r && r.runDrinkLabel) ? r.runDrinkLabel : '',
run_drink_sodium_nominal: (r && r.runDrinkSodium != null) ? r.runDrinkSodium : 0,
run_drink_credit_per_hr: (r && r.runDrinkCreditPerHr != null) ? r.runDrinkCreditPerHr : 0,
run_intake_factor: RUN_INTAKE_FACTOR,
/* ─── Fluid-ceiling note (v3.18) ───────────── */
fluid_ceiling_note_fired: (r && r.fluidCeilingNote) ? 'yes' : 'no',
fluid_ceiling_note_html: (r && r.fluidCeilingNote) ? buildFluidCeilingNoteEmailHtml(r.fluidCeilingNote) : '',
/* ─── Gut training note (v3.20) ────────────── */
gut_note_html: buildGutTrainingNoteHtml(r),
/* ─── Additional columns ───────────────────── */
Sex: state.sex || '',
'Age Bracket': state.ageBracket || '',
'Cramping History': state.crampFreq || ''
    };
  }
  function fireWebhook(r){
    if(!WEBHOOK) return;
    if(!state.email){ try { state.email = localStorage.getItem('lw_email') || ''; } catch(e){} }
    if(!state.email) return;   // never fire a blank-email payload — it fails Make validation and can stop the scenario
    try {
      fetch(WEBHOOK, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(buildPayload(r))
      }).catch(function(){});
    } catch(e){}
  }

  function buildEmailHtml(r){
    // Compact email body matching v2.8 structure
    var phases = determinePhases(r);
    var html = '<div style="font-family:Arial,sans-serif;max-width:600px;margin:0 auto;background:#fff;color:#0B0626;">';
    html += '<div style="background:#140049;color:#fff;padding:32px 24px;text-align:center;">';
    html += '<div style="font-family:monospace;font-size:11px;letter-spacing:0.22em;color:#9CF9DA;margin-bottom:16px;">YOUR LYTEWORK PROTOCOL</div>';
    html += '<h1 style="font-size:24px;margin:0;font-weight:400;letter-spacing:-0.03em;">Your hydration strategy is ready.</h1>';
    html += '</div>';
    html += '<div style="padding:32px 24px;">';
    html += '<p>'+buildSummary(r).replace(/<\/?strong>/g,'')+'</p>';
    html += '<table style="width:100%;border-collapse:collapse;margin:24px 0;">';
    html += '<tr><td style="padding:12px;border-bottom:1px solid #eee;"><strong>Fluid:</strong></td><td style="padding:12px;border-bottom:1px solid #eee;text-align:right;">'+r.fluidPerHr+' ml/hr · '+r.totals.fluid+' ml total</td></tr>';
    html += '<tr><td style="padding:12px;border-bottom:1px solid #eee;"><strong>Sodium:</strong></td><td style="padding:12px;border-bottom:1px solid #eee;text-align:right;">'+r.sodiumPerHr+' mg/hr · '+r.totals.sodium+' mg total</td></tr>';
    html += '<tr><td style="padding:12px;border-bottom:1px solid #eee;"><strong>Capsules:</strong></td><td style="padding:12px;border-bottom:1px solid #eee;text-align:right;">'+r.capsulesPerHr.toFixed(1)+' /hr · ~'+Math.ceil(r.totals.capsules)+' total</td></tr>';
    html += '<tr><td style="padding:12px;"><strong>Carbs:</strong></td><td style="padding:12px;text-align:right;">'+r.carbsPerHr+' g/hr · '+r.totals.carbs+' g total</td></tr>';
    html += '</table>';
    html += '<p style="font-size:13px;color:#666;">Visit your calculator results page for the full Pre / In / Post protocol breakdown, cadence guidance, and calculation transparency.</p>';
    html += '<div style="text-align:center;margin:32px 0;">';
    html += '<a href="'+lwHpUrl(r)+'" style="display:inline-block;background:#140049;color:#FFFFFF;padding:16px 30px;border-radius:100px;font-family:\'IBM Plex Sans\',Arial,sans-serif;font-weight:500;font-size:15px;letter-spacing:normal;text-decoration:none;">See capsules &rarr;</a>';
    html += '</div>';
    html += '</div>';
    html += '<div style="background:#f9f9f9;padding:20px 24px;font-size:11px;color:#666;text-align:center;">Lytework Labs · Control Sodium. Not Your Drink.</div>';
    html += '</div>';
    return html;
  }

  /* ════════════════════════════════════════════════════════
     EVENT WIRING
  ════════════════════════════════════════════════════════ */
  function init(){
    // Weight input
    var weight = $('#lwWeight');
    if(weight) weight.addEventListener('input', function(e){ set('weight', parseFloat(e.target.value) || null); });

    // Weight units
    $$('#lwWeightUnits .lw-his__unit-btn').forEach(function(b){
      b.addEventListener('click', function(){
        $$('#lwWeightUnits .lw-his__unit-btn').forEach(function(x){ x.classList.remove('is-active'); });
        b.classList.add('is-active');
        set('weightUnit', b.dataset.unit);
      });
    });

    // Card selects — generic handler
    function wireCardSelect(containerId, stateKey, extra){
      var c = $('#'+containerId);
      if(!c) return;
      $$('.lw-his__card-btn', c).forEach(function(b){
        b.addEventListener('click', function(){
          $$('.lw-his__card-btn', c).forEach(function(x){ x.classList.remove('is-selected'); });
          b.classList.add('is-selected');
          set(stateKey, b.dataset.value);
          if(extra) extra(b);
        });
      });
    }
    wireCardSelect('lwSex', 'sex');
    wireCardSelect('lwAgeBracket', 'ageBracket');
    wireCardSelect('lwExperience', 'experience');
    wireCardSelect('lwGutSensitivity', 'gutSensitivity');
    wireCardSelect('lwHeatAcclim', 'heatAcclim', function(){
      var warn = $('#lwAcclimRequired'); if(warn) warn.style.display = 'none';
    });
    wireCardSelect('lwHumidity', 'humidity');
    wireCardSelect('lwSetting', 'setting', function(b){
      var sunField = $('#lwSunField');
      if(sunField) sunField.style.display = b.dataset.value === 'indoor' ? 'none' : 'block';
    });
    wireCardSelect('lwSun', 'sun');
    wireCardSelect('lwSweatPreset', 'sweatPreset', function(b){
      set('sweatRate', parseFloat(b.dataset.rate));
    });
    wireCardSelect('lwSodiumPreset', 'sodiumPreset', function(b){
      set('sodiumConc', parseInt(b.dataset.conc));
    });
    wireCardSelect('lwCrampFreq', 'crampFreq');
    wireCardSelect('lwSessionType', 'sessionType');
    wireCardSelect('lwSport', 'sport', function(b){
      var triGroup = $('#lwTriFormatGroup');
      if(triGroup) triGroup.style.display = b.dataset.value === 'triathlon' ? 'block' : 'none';
      // Set duration based on tri format if triathlon
      if(b.dataset.value === 'triathlon'){
        var selectedTri = $('#lwTriFormat .lw-his__card-btn.is-selected');
        if(selectedTri){
          // v3.41: seed the canonical split from the selected format too, so
          // switching INTO triathlon can't inherit a stale shape.
          var ts = parseFloat(selectedTri.dataset.swim);
          var tb = parseFloat(selectedTri.dataset.bike);
          var tr = parseFloat(selectedTri.dataset.run);
          if(isFinite(ts) && isFinite(tb) && isFinite(tr)){
            state.triBaseSplit = { swim: ts, bike: tb, run: tr };
          }
          var triMin = (parseFloat(selectedTri.dataset.swim) + parseFloat(selectedTri.dataset.bike) + parseFloat(selectedTri.dataset.run)) * 60;
          var slider = $('#lwDuration');
          if(slider){ slider.value = durMinToPos(Math.round(triMin)); }
          set('durationMin', Math.round(triMin));
          var dd = $('#lwDurationDisplay'); if(dd) dd.textContent = durStr(Math.round(triMin));
        }
      }
    });
    wireCardSelect('lwTriFormat', 'triFormat', function(b){
      /* v3.41 — THE FIX. This handler used to call set() three times, and set()
         runs updatePreview() -> calc, which normalised the legs against the OLD
         durationMin between each write. So after writing swim, {newSwim, oldBike,
         oldRun} got squashed onto the old total; after writing bike, the already-
         squashed swim/run got squashed again; and so on. Three formats' worth of
         compounding left the leg that was written LAST holding ~70% of the
         session — a 140.6 came out as a 25 min swim, 186 min bike and 514 min
         run. It also meant triMin was read back off the corrupted state, so
         picking a format never moved the duration off its previous value.
         Now: write the base split and the duration atomically, derive the legs
         once, and repaint with a single updatePreview(). */
      var s = parseFloat(b.dataset.swim);
      var bk = parseFloat(b.dataset.bike);
      var rn = parseFloat(b.dataset.run);
      if(!isFinite(s) || !isFinite(bk) || !isFinite(rn)) return;
      var triMin = Math.round((s + bk + rn) * 60);
      state.triBaseSplit = { swim: s, bike: bk, run: rn };
      state.durationMin = triMin;
      applyTriSplit();
      var slider = $('#lwDuration'); if(slider) slider.value = durMinToPos(triMin);
      var dd = $('#lwDurationDisplay'); if(dd) dd.textContent = durStr(triMin);
      updatePreview();
    });
    wireCardSelect('lwIntensity', 'intensity');
    wireCardSelect('lwAidStation', 'aidStation');
    wireCardSelect('lwDrinkSetup', 'drinkSetup', function(b){
      var v = b.dataset.value;
      var picker = $('#lwProductPicker');
      var panel = $('#lwDrinkSodiumPanel');
      if(picker) picker.style.display = v === 'picker' ? 'block' : 'none';
      if(panel) panel.style.display = v === 'custom' ? 'block' : 'none';
      if(v === 'water'){
        set('drinkProduct', null);
        set('drinkSodiumMg', 0);
      }
    });

    // Product grid
    $$('#lwProductGrid .lw-his__product-btn').forEach(function(b){
      b.addEventListener('click', function(){
        $$('#lwProductGrid .lw-his__product-btn').forEach(function(x){ x.classList.remove('is-selected'); });
        b.classList.add('is-selected');
        set('drinkProduct', b.dataset.key);
      });
    });

    // Run product grid (triathlon two-picker)
    $$('#lwRunProductGrid .lw-his__product-btn').forEach(function(b){
      b.addEventListener('click', function(){
        $$('#lwRunProductGrid .lw-his__product-btn').forEach(function(x){ x.classList.remove('is-selected'); });
        b.classList.add('is-selected');
        set('drinkProductRun', b.dataset.key);
      });
    });

    // Temperature slider
    var tempSlider = $('#lwTemp');
    if(tempSlider){
      tempSlider.addEventListener('input', function(e){
        var v = parseInt(e.target.value);
        set('tempC', v);
        var disp = $('#lwTempDisplay');
        if(disp) disp.textContent = state.tempUnit === 'f' ? Math.round(v*1.8+32) : v;
      });
    }
    $$('#lwTempUnits .lw-his__unit-btn').forEach(function(b){
      b.addEventListener('click', function(){
        $$('#lwTempUnits .lw-his__unit-btn').forEach(function(x){ x.classList.remove('is-active'); });
        b.classList.add('is-active');
        set('tempUnit', b.dataset.tempUnit);
        var disp = $('#lwTempDisplay');
        if(disp) disp.textContent = state.tempUnit === 'f' ? Math.round(state.tempC*1.8+32) : state.tempC;
      });
    });

    // Race-day forecast (DRAFT) — only present when the section setting is ON
    var wxBtn = $('#lwWxBtn');
    if(wxBtn){
      var placeInput = $('#lwWxPlace');
      var resultsEl = $('#lwWxResults');
      var wxSelected = null;   // chosen { lat, lon, label }
      var wxResults = [];
      var wxActiveIdx = -1;
      var wxDebounce = null;
      var statusEl = $('#lwWxStatus');

      function wxEsc(s){ return String(s).replace(/[&<>"]/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      function wxMsg(text, mod){
        if(!statusEl) return;
        statusEl.innerHTML = '<div class="lw-his__wx-msg' + (mod ? ' lw-his__wx-msg--' + mod : '') + '">' + wxEsc(text) + '</div>';
      }
      function wxHumidityLabel(b){ return b === 'low' ? 'Low humidity' : (b === 'high' ? 'High humidity' : 'Moderate humidity'); }
      function wxSunLabel(s){ return s === 'full' ? 'Full sun' : (s === 'partial' ? 'Partial sun' : (s === 'shaded' ? 'Overcast / shade' : '')); }
      function wxOut(o){
        if(!statusEl) return;
        var chips = '<span class="lw-his__wx-chip lw-his__wx-chip--lead"><b>' + o.tempC + '\u00B0C</b></span>';
        chips += '<span class="lw-his__wx-chip">' + Math.round(o.rh) + '% RH \u00B7 ' + wxEsc(wxHumidityLabel(o.humidity)) + '</span>';
        if(o.sun){ chips += '<span class="lw-his__wx-chip">' + wxEsc(wxSunLabel(o.sun)) + '</span>'; }
        var src = (o.source === 'forecast')
          ? '<b>Forecast</b> \u00B7 ' + o.startHour + ':00 start, ' + o.hrs + 'h window'
          : '<b>Typical</b> \u00B7 average of the last ' + o.years + ' years';
        statusEl.innerHTML =
          '<div class="lw-his__wx-out">' +
            '<div class="lw-his__wx-out-head">Race-day conditions</div>' +
            '<div class="lw-his__wx-chips">' + chips + '</div>' +
            '<div class="lw-his__wx-cap">' + src + ' \u00B7 ' + wxEsc(o.label) + ' \u00B7 Weather: Open-Meteo</div>' +
          '</div>';
      }

      function wxLabel(g){ return [g.name, g.admin1, g.country_code].filter(Boolean).join(', '); }
      function wxHideResults(){
        if(resultsEl){ resultsEl.innerHTML = ''; resultsEl.classList.remove('is-open'); }
        if(placeInput) placeInput.setAttribute('aria-expanded', 'false');
        wxActiveIdx = -1;
      }
      function wxPick(g){
        wxSelected = { lat: g.latitude, lon: g.longitude, label: wxLabel(g) };
        if(placeInput) placeInput.value = wxSelected.label;
        wxHideResults();
      }
      function wxRenderResults(list){
        wxResults = list;
        if(!resultsEl) return;
        if(!list.length){ wxHideResults(); return; }
        resultsEl.innerHTML = '';
        list.forEach(function(g){
          var li = document.createElement('li');
          li.className = 'lw-his__wx-result';
          li.setAttribute('role', 'option');
          li.textContent = wxLabel(g);
          li.addEventListener('mousedown', function(ev){ ev.preventDefault(); wxPick(g); });
          resultsEl.appendChild(li);
        });
        resultsEl.classList.add('is-open');
        if(placeInput) placeInput.setAttribute('aria-expanded', 'true');
      }
      function wxSetActive(idx){
        var items = resultsEl ? resultsEl.querySelectorAll('.lw-his__wx-result') : [];
        if(!items.length) return;
        if(idx < 0) idx = items.length - 1;
        if(idx >= items.length) idx = 0;
        wxActiveIdx = idx;
        for(var i = 0; i < items.length; i++){ items[i].classList.toggle('is-active', i === idx); }
      }

      if(placeInput){
        placeInput.setAttribute('role', 'combobox');
        placeInput.setAttribute('aria-autocomplete', 'list');
        placeInput.setAttribute('aria-expanded', 'false');
        placeInput.addEventListener('input', function(){
          wxSelected = null;   // typing invalidates a prior pick
          var q = placeInput.value.trim();
          if(wxDebounce) clearTimeout(wxDebounce);
          if(q.length < 2){ wxHideResults(); return; }
          wxDebounce = setTimeout(function(){
            lwWxGeocode(q).then(function(results){
              if(placeInput.value.trim() !== q) return;   // drop stale responses
              wxRenderResults(results.slice(0, 6));
            }).catch(function(){ wxHideResults(); });
          }, 280);
        });
        placeInput.addEventListener('keydown', function(e){
          if(!resultsEl || !resultsEl.classList.contains('is-open')) return;
          if(e.key === 'ArrowDown'){ e.preventDefault(); wxSetActive(wxActiveIdx + 1); }
          else if(e.key === 'ArrowUp'){ e.preventDefault(); wxSetActive(wxActiveIdx - 1); }
          else if(e.key === 'Enter' && wxActiveIdx >= 0 && wxResults[wxActiveIdx]){ e.preventDefault(); wxPick(wxResults[wxActiveIdx]); }
          else if(e.key === 'Escape'){ wxHideResults(); }
        });
        placeInput.addEventListener('blur', function(){ setTimeout(wxHideResults, 150); });
      }

      function wxRun(loc, dateStr, startHour){
        var label = loc.label || wxLabel(loc);
        var lat = (loc.lat != null) ? loc.lat : loc.latitude;
        var lon = (loc.lon != null) ? loc.lon : loc.longitude;
        return lwWxGetConditions(lat, lon, dateStr, startHour, state.durationMin).then(function(res){
          if(!res){ wxMsg('No conditions data for that place and date — enter the values manually below.', 'err'); return; }
          lwWxApply(res.temp, res.rh, res.cloud);
          var tC = Math.round(res.temp); if(tC < 5) tC = 5; if(tC > 45) tC = 45;
          wxOut({
            tempC: tC,
            rh: res.rh,
            humidity: lwWxHumidityBucket(res.rh),
            sun: (state.setting === 'outdoor') ? lwWxSunBucket(res.cloud) : null,
            source: res.source,
            startHour: startHour,
            hrs: Math.max(1, Math.ceil((state.durationMin || 60) / 60)),
            years: LW_WX.climYears,
            label: label
          });
        });
      }

      wxBtn.addEventListener('click', function(){
        var dateEl = $('#lwWxDate'), timeEl = $('#lwWxTime');
        var place = placeInput ? placeInput.value : '';
        var dateStr = dateEl ? dateEl.value : '';
        var timeStr = (timeEl && timeEl.value) ? timeEl.value : '07:00';
        if(!place || !place.trim() || !dateStr){ wxMsg('Enter a race location and date first.'); return; }
        var startHour = parseInt(timeStr.split(':')[0], 10); if(isNaN(startHour)) startHour = 7;
        wxHideResults();
        wxMsg('Checking conditions\u2026', 'load');
        if(wxSelected){
          wxRun(wxSelected, dateStr, startHour).catch(function(){ wxMsg('Couldn\'t fetch conditions right now — enter the values manually below.', 'err'); });
          return;
        }
        // No explicit pick — geocode the typed text and use the best match
        lwWxGeocode(place).then(function(results){
          if(!results.length){ wxMsg('Couldn\'t find that place — pick one from the list as you type, or enter the values manually below.', 'err'); return; }
          return wxRun(results[0], dateStr, startHour);
        }).catch(function(){ wxMsg('Couldn\'t fetch conditions right now — enter the values manually below.', 'err'); });
      });
    }

    // Duration slider (v3.2.1: rescales triathlon segments when in triathlon mode)
var durSlider = $('#lwDuration');
if(durSlider){
  durSlider.addEventListener('input', function(e){
    var v = durPosToMin(parseInt(e.target.value));
    
    /* v3.41: no in-place rescale here any more. The slider only moves the
       total; calc derives the legs from triBaseSplit on every pass, so dragging
       preserves the format's shape exactly no matter how many input events
       fire. The old block re-scaled live values on every event, which was
       self-consistent in isolation but locked in any corrupted ratio it
       inherited. */
    set('durationMin', v);
    var dd = $('#lwDurationDisplay'); if(dd) dd.textContent = durStr(v);
  });
}

    // Custom sweat/sodium
    /* Custom sweat-test inputs are clamped in JS as well as via the HTML max
       attribute (v3.32) — the attribute is advisory in several browsers and
       does nothing against paste or programmatic entry. Bounds mirror the
       documented physiological ranges shown in the field tooltips. */
    function clampNum(v, lo, hi){
      if(v == null || !isFinite(v)) return null;
      return Math.min(hi, Math.max(lo, v));
    }
    var sweatCustom = $('#lwSweatCustom');
    if(sweatCustom) sweatCustom.addEventListener('input', function(e){
      set('sweatCustom', clampNum(parseFloat(e.target.value) || null, 0.2, 3.5));
    });
    var sodiumCustom = $('#lwSodiumCustom');
    if(sodiumCustom) sodiumCustom.addEventListener('input', function(e){
      set('sodiumCustom', clampNum(parseInt(e.target.value) || null, 200, 2600));
      updateSweatTestConversion();
    });
    /* v3.40: most commercial sweat tests report a regional (forearm patch)
       value, which runs systematically higher than whole-body. Let the athlete
       say which they have, and convert. */
    $$('#lwSodiumMode .lw-his__unit-btn').forEach(function(b){
      b.addEventListener('click', function(){
        $$('#lwSodiumMode .lw-his__unit-btn').forEach(function(x){ x.classList.remove('is-active'); });
        b.classList.add('is-active');
        set('sodiumCustomMode', b.dataset.sodiumMode);
        updateSweatTestConversion();
      });
    });
    function updateSweatTestConversion(){
      var el = $('#lwSodiumConverted'); if(!el) return;
      var wb = effectiveSodiumCustom();
      if(wb == null){ el.style.display = 'none'; return; }
      el.style.display = 'block';
      el.innerHTML = state.sodiumCustomMode === 'regional'
        ? 'Converted to a whole-body equivalent of <strong>' + wb + ' mg/L</strong> using the published regional-to-whole-body regression (Baker et al., 2016).'
        : 'Using <strong>' + wb + ' mg/L</strong> as a whole-body value. If your test reported a forearm or patch result, switch to Regional above.';
    }

    // Sweat test panel toggle
    var sweatToggle = $('#lwSweatTestToggle');
    if(sweatToggle){
      sweatToggle.addEventListener('click', function(){
        var panel = $('#lwSweatTestPanel');
        var isOpen = panel.classList.toggle('is-open');
        sweatToggle.setAttribute('aria-expanded', isOpen);
      });
    }

    // Custom drink sodium
    var drinkSod = $('#lwDrinkSodiumMg');
    if(drinkSod){
      drinkSod.addEventListener('input', function(e){
        var v = parseInt(e.target.value) || 0;
        set('drinkSodiumMg', v);
        var warn = $('#lwSodiumWarning');
        if(warn) warn.style.display = v > 1500 ? 'block' : 'none';
      });
    }

    // Step navigation
    $$('.lw-his__btn-next').forEach(function(b){
      b.addEventListener('click', function(){
        /* v3.40: heat acclimation is the single largest lever in the model -
           it moves the sodium target by roughly a third across its range - and
           it was defaulting to "Moderately acclimated", the third of four
           options, which quietly cut sweat [Na+] by 18% for anyone who never
           touched the field. There is no defensible default, so it must be
           chosen. */
        if(parseInt(b.dataset.next) === 2 && !state.heatAcclim){
          var grp = $('#lwHeatAcclim');
          var warn = $('#lwAcclimRequired');
          if(warn) warn.style.display = 'block';
          if(grp){
            var rect = grp.getBoundingClientRect();
            window.scrollTo({ top: window.pageYOffset + rect.top - 120, behavior: 'smooth' });
          }
          return;
        }
        goToStep(parseInt(b.dataset.next));
      });
    });
    $$('.lw-his__btn-back, [data-back]').forEach(function(b){
      b.addEventListener('click', function(){ goToStep(parseInt(b.dataset.back)); });
    });
    $$('.lw-his__progress-step').forEach(function(b){
      b.addEventListener('click', function(){
        var n = parseInt(b.dataset.step);
        // Only allow forward to current or back to completed
        if(n <= state.step || b.classList.contains('is-complete')) goToStep(n);
      });
    });

    // Protocol tabs
    $$('.lw-his__tab').forEach(function(t){
  t.addEventListener('click', function(){
    $$('.lw-his__tab').forEach(function(x){ x.classList.remove('is-active'); });
    t.classList.add('is-active');
    var key = t.dataset.protocolTab;
    $$('.lw-his__protocol-panel').forEach(function(p){
      p.classList.toggle('is-active', p.dataset.protocolPanel === key);
    });
    // v3.1: Scroll to top of the active panel (where the content actually starts)
    setTimeout(function(){
      var activePanel = $('.lw-his__protocol-panel.is-active');
      if(activePanel){
        var rect = activePanel.getBoundingClientRect();
        var headerOffset = 90;
        window.scrollTo({
          top: window.pageYOffset + rect.top - headerOffset,
          behavior: 'smooth'
        });
      }
    }, 50);
  });
});

    // Email gate
    var gateBtn = $('#lwGateSubmit');
    if(gateBtn){
      gateBtn.addEventListener('click', function(){
        var input = $('#lwGateEmail');
        var email = input ? input.value.trim() : '';
        if(!email || !/.+@.+\..+/.test(email)){
          if(input) input.style.borderColor = '#ff8a78';
          return;
        }
        state.email = email;
        state.emailUnlocked = true;
        var gate = $('#lwGate');
        if(gate){
          gate.classList.add('is-unlocked');
          gate.style.display = '';
        }
        var gated = $('#lwGatedResults');
if(gated){
  gated.classList.add('is-unlocked');
  gated.style.display = 'block';   // clear the inline display:none the locked acknowledge branch may have set
  // v3.1: Scroll to top of gated content so user lands at the start
  setTimeout(function(){
    var rect = gated.getBoundingClientRect();
    window.scrollTo({
      top: window.pageYOffset + rect.top - 90,
      behavior: 'smooth'
    });
  }, 100);
}
        // Persist
        try { localStorage.setItem('lw_email', email); } catch(e){}
        // Save profile
        try {
          var profile = { weight: state.weight, weightUnit: state.weightUnit, sex: state.sex, ageBracket: state.ageBracket, experience: state.experience, gutSensitivity: state.gutSensitivity, heatAcclim: state.heatAcclim, sweatPreset: state.sweatPreset, sweatCustom: state.sweatCustom, sodiumPreset: state.sodiumPreset, sodiumCustom: state.sodiumCustom, sodiumCustomMode: state.sodiumCustomMode, crampFreq: state.crampFreq };
          localStorage.setItem('lw_profile_full', JSON.stringify(profile));
          var compact = { weight: state.weight, weightUnit: state.weightUnit, sweatRate: state.results ? state.results.sweatRate : null, sodiumPerHr: state.results ? state.results.sodiumPerHr : null, fluidPerHr: state.results ? state.results.fluidPerHr : null };
          localStorage.setItem('lw_profile', JSON.stringify(compact));
        } catch(e){}
        // Fire webhook with email
        if(state.results) fireWebhook(state.results);
      });
    }

    // Resend button
    var resendBtn = $('#lwResendBtn');
    if(resendBtn){
      resendBtn.addEventListener('click', function(){
        if(state.results) fireWebhook(state.results);
        var confirm = $('#lwResendConfirm');
        if(confirm){
          confirm.style.display = 'inline-block';
          setTimeout(function(){ confirm.style.display = 'none'; }, 3000);
        }
      });
    }

    // v3.1: Coach button — opens mailto directly, no slide-up panel
var coachBtn = $('#lwCoachBtn');
if(coachBtn){
  coachBtn.addEventListener('click', function(){
    if(!state.results) return;
    var subject = encodeURIComponent('Hydration plan for review — ' + durStr(state.durationMin) + ' ' + state.sport);
    var body = encodeURIComponent(buildCoachEmailBody(state.results));
    window.location.href = 'mailto:?subject=' + subject + '&body=' + body;
  });
}

    // Share button
    var shareBtn = $('#lwShareBtn');
    if(shareBtn){
      shareBtn.addEventListener('click', function(){
        var r = state.results;
        if(!r) return;
        var text = buildShareText(r);
        if(navigator.share){
          navigator.share({ title: 'My Lytework hydration plan', text: text }).catch(function(){});
        } else {
          try { navigator.clipboard.writeText(text); shareBtn.textContent = 'COPIED ✓'; setTimeout(function(){ shareBtn.textContent = 'Share plan'; }, 2000); } catch(e){}
        }
      });
    }

    // Preview toggle
    var pvToggle = $('#lwPreviewToggle');
    if(pvToggle){
      pvToggle.addEventListener('click', function(){
        var card = $('#lwPreviewCard');
        if(card) card.classList.toggle('is-collapsed');
      });
    }

    // Welcome back clear (v3.2.3: full reset, not just banner hide)
var wbClear = $('#lwWelcomeBackClear');
if(wbClear){
  wbClear.addEventListener('click', function(){
    // 1. Clear all localStorage
    try { 
      localStorage.removeItem('lw_profile_full'); 
      localStorage.removeItem('lw_profile');
      localStorage.removeItem('lw_email');
    } catch(e){}
    
    // 2. Reset state to defaults
    state.weight = null;
    state.weightUnit = 'kg';
    state.sex = null;
    state.ageBracket = null;
    state.experience = 'intermediate';
    state.gutSensitivity = 'moderate';
    state.heatAcclim = null;
    state.tempC = 20;
    state.tempUnit = 'c';
    state.humidity = 'moderate';
    state.setting = 'outdoor';
    state.sun = 'shaded';
    state.sweatPreset = 'moderate';
    state.sweatRate = 1.0;
    state.sweatCustom = null;
    state.sodiumPreset = 'moderate';
    state.sodiumConc = 830;
    state.sodiumCustom = null;
    state.sodiumCustomMode = 'wholebody';
    state.crampFreq = 'never';
    state.sessionType = 'training';
    state.sport = 'cycle';
    state.triFormat = 'olympic';
    state.triBaseSplit = { swim: 0.33, bike: 1.0, run: 0.67 };
    state.triSwim = 0.33;
    state.triBike = 1.0;
    state.triRun = 0.67;
    state.durationMin = 120;
    state.intensity = 'moderate';
    state.drinkSetup = 'water';
    state.drinkProduct = null;
    state.drinkProductRun = 'same';
    state.drinkSodiumMg = 0;
    state.aidStation = 'carry';
    state.email = null;
    state.emailUnlocked = false;
    state.results = null;
    
    // 3. Reset form UI — clear all selections then reapply defaults
    // Clear all card selections across all groups
    $$('.lw-his__card-btn.is-selected').forEach(function(b){ b.classList.remove('is-selected'); });
    
    // Reapply defaults to match initial state
    var defaults = {
      'lwExperience': 'intermediate',
      'lwGutSensitivity': 'moderate',
      'lwHumidity': 'moderate',
      'lwSetting': 'outdoor',
      'lwSun': 'shaded',
      'lwSweatPreset': 'moderate',
      'lwSodiumPreset': 'moderate',
      'lwCrampFreq': 'never',
      'lwSessionType': 'training',
      'lwSport': 'cycle',
      'lwTriFormat': 'olympic',
      'lwIntensity': 'moderate',
      'lwDrinkSetup': 'water',
      'lwAidStation': 'carry'
    };
    Object.keys(defaults).forEach(function(groupId){
      var btn = $('#'+groupId+' .lw-his__card-btn[data-value="'+defaults[groupId]+'"]');
      if(btn) btn.classList.add('is-selected');
    });
    
    // Reset input fields
    var weight = $('#lwWeight'); if(weight) weight.value = '';
    var sweatCustom = $('#lwSweatCustom'); if(sweatCustom) sweatCustom.value = '';
    var sodiumCustom = $('#lwSodiumCustom'); if(sodiumCustom) sodiumCustom.value = '';
    var drinkSod = $('#lwDrinkSodiumMg'); if(drinkSod) drinkSod.value = '';
    
    // Reset sliders
    var tempSlider = $('#lwTemp'); if(tempSlider) tempSlider.value = 20;
    var tempDisp = $('#lwTempDisplay'); if(tempDisp) tempDisp.textContent = '20';
    var durSlider = $('#lwDuration'); if(durSlider) durSlider.value = durMinToPos(120);
    var durDisp = $('#lwDurationDisplay'); if(durDisp) durDisp.textContent = durStr(120);
    
    // Reset unit toggles
    $$('#lwWeightUnits .lw-his__unit-btn').forEach(function(x){ x.classList.remove('is-active'); });
    var kgBtn = $('#lwWeightUnits .lw-his__unit-btn[data-unit="kg"]');
    if(kgBtn) kgBtn.classList.add('is-active');
    $$('#lwTempUnits .lw-his__unit-btn').forEach(function(x){ x.classList.remove('is-active'); });
    var cBtn = $('#lwTempUnits .lw-his__unit-btn[data-temp-unit="c"]');
    if(cBtn) cBtn.classList.add('is-active');
    
    // Hide conditional panels
    var triGroup = $('#lwTriFormatGroup'); if(triGroup) triGroup.style.display = 'none';
    var picker = $('#lwProductPicker'); if(picker) picker.style.display = 'none';
    var panel = $('#lwDrinkSodiumPanel'); if(panel) panel.style.display = 'none';
    var sweatPanel = $('#lwSweatTestPanel'); if(sweatPanel) sweatPanel.classList.remove('is-open');
    var sweatToggleBtn = $('#lwSweatTestToggle'); if(sweatToggleBtn) sweatToggleBtn.setAttribute('aria-expanded', 'false');
    
    // Clear product grid selection
    $$('#lwProductGrid .lw-his__product-btn.is-selected').forEach(function(x){ x.classList.remove('is-selected'); });
    // Reset run drink grid to "Same as bike" and hide the run picker
    $$('#lwRunProductGrid .lw-his__product-btn').forEach(function(x){ x.classList.remove('is-selected'); });
    var runSameBtn = $('#lwRunProductGrid .lw-his__product-btn[data-key="same"]'); if(runSameBtn) runSameBtn.classList.add('is-selected');
    var runGrp = $('#lwRunDrinkGroup'); if(runGrp) runGrp.style.display = 'none';
    
    // Hide welcome-back banner
    var wb = $('#lwWelcomeBack'); if(wb) wb.style.display = 'none';
    
    // Hide any acknowledgement banner
    var ackBanner = $('#lwAckBanner'); if(ackBanner) ackBanner.classList.remove('is-active');
    
    // Update live preview
    updatePreview();
    
    // Navigate to step 1
    goToStep(1);
  });
}

    applySavedProfile();
    updatePreview();
  }

  function buildCoachEmailBody(r){
    if(!r) return '';
    var lines = [];
    lines.push('Hi coach,');
    lines.push('');
    lines.push('Built a hydration and fuelling plan for an upcoming session — would value a quick sense-check.');
    lines.push('');
    lines.push('SESSION');
    lines.push('• '+durStr(state.durationMin)+' '+state.sport+' '+(state.sessionType==='race'?'race':'training'));
    lines.push('• Conditions: '+state.tempC+'°C, '+state.humidity+' humidity, '+state.setting);
    lines.push('• Intensity: '+state.intensity);
    lines.push('');
    lines.push('TARGETS PER HOUR');
    lines.push('• Fluid: '+r.fluidPerHr+' ml');
    lines.push('• Sodium: '+r.sodiumPerHr+' mg');
    lines.push('• Carbs: '+r.carbsPerHr+' g');
    lines.push('• Capsules: '+r.capsulesPerHr.toFixed(1)+' ('+CAPSULE_NA+' mg each)');
    if(r.drinkLabel) lines.push('• Drink: '+r.drinkLabel+' (~'+r.drinkSodium+' mg/hr from drink)');
    lines.push('');
    lines.push('PROFILE');
    lines.push('• Sweat rate: '+r.sweatRate.toFixed(2)+' L/hr');
    lines.push('• Sweat sodium: '+r.sodiumConc+' mg/L');
    lines.push('• Heat acclim: '+state.heatAcclim);
    lines.push('• Confidence: '+r.confidence+'%');
    lines.push('');
    lines.push('Built via lyteworklabs.com/pages/hydration-profile');
    return lines.join('\n');
  }

  function buildShareText(r){
  if(!r) return '';
  var sportLabel = { run:'Run', cycle:'Cycle', swim:'Swim', triathlon:'Triathlon', other:'Endurance' }[state.sport] || 'Session';
  var sessionWord = state.sessionType === 'race' ? 'race' : 'training';
  var lines = [];
  lines.push('Just mapped my hydration plan for a ' + durStr(state.durationMin) + ' ' + sportLabel.toLowerCase() + ' ' + sessionWord + ':');
  lines.push('');
  lines.push('→ ' + r.fluidPerHr + ' ml/hr fluid');
  lines.push('→ ' + r.sodiumPerHr + ' mg/hr sodium');
  lines.push('→ ' + r.carbsPerHr + ' g/hr carbs');
  lines.push('→ ' + Math.ceil(r.totals.capsules) + ' capsules total');
  lines.push('');
  lines.push('Built free at lyteworklabs.com — sodium dosed for your physiology, not the average.');
  return lines.join('\n');
}

  function applySavedProfile(){
    try {
      var savedEmail = localStorage.getItem('lw_email'); if(savedEmail) state.email = savedEmail;
      var raw = localStorage.getItem('lw_profile_full');
      if(!raw) return;
      var p = JSON.parse(raw);
      if(!p) return;
      // Apply each
      if(p.weight){ state.weight = p.weight; var w = $('#lwWeight'); if(w) w.value = p.weight; }
      if(p.weightUnit){ state.weightUnit = p.weightUnit; }
      if(p.sex){ state.sex = p.sex; var sb = $('#lwSex .lw-his__card-btn[data-value="'+p.sex+'"]'); if(sb) sb.click(); }
      if(p.ageBracket){ state.ageBracket = p.ageBracket; var ab = $('#lwAgeBracket .lw-his__card-btn[data-value="'+p.ageBracket+'"]'); if(ab) ab.click(); }
      if(p.experience){ state.experience = p.experience; var eb = $('#lwExperience .lw-his__card-btn[data-value="'+p.experience+'"]'); if(eb) eb.click(); }
      if(p.gutSensitivity){ state.gutSensitivity = p.gutSensitivity; var gb = $('#lwGutSensitivity .lw-his__card-btn[data-value="'+p.gutSensitivity+'"]'); if(gb) gb.click(); }
      if(p.heatAcclim){ state.heatAcclim = p.heatAcclim; var hb = $('#lwHeatAcclim .lw-his__card-btn[data-value="'+p.heatAcclim+'"]'); if(hb) hb.click(); }
      if(p.sweatPreset){ state.sweatPreset = p.sweatPreset; var swb = $('#lwSweatPreset .lw-his__card-btn[data-value="'+p.sweatPreset+'"]'); if(swb) swb.click(); }
      if(p.sodiumPreset){ state.sodiumPreset = p.sodiumPreset; var sodb = $('#lwSodiumPreset .lw-his__card-btn[data-value="'+p.sodiumPreset+'"]'); if(sodb) sodb.click(); }
      if(p.crampFreq){ state.crampFreq = p.crampFreq; var cb = $('#lwCrampFreq .lw-his__card-btn[data-value="'+p.crampFreq+'"]'); if(cb) cb.click(); }
      /* v3.37: saved profiles from older builds may carry values outside the
         current physiological bounds (sodium max was 3000 until v3.32) —
         clamp on restore, or the ceiling is bypassed on every return visit. */
      if(p.sweatCustom){ state.sweatCustom = Math.min(3.5, Math.max(0.2, p.sweatCustom)); var swc = $('#lwSweatCustom'); if(swc) swc.value = state.sweatCustom; }
      if(p.sodiumCustom){ state.sodiumCustom = Math.min(2600, Math.max(200, p.sodiumCustom)); var sodc = $('#lwSodiumCustom'); if(sodc) sodc.value = state.sodiumCustom; }
      if(p.sodiumCustomMode){ state.sodiumCustomMode = p.sodiumCustomMode;
        var smb = $('#lwSodiumMode .lw-his__unit-btn[data-sodium-mode="'+p.sodiumCustomMode+'"]');
        if(smb){ $$('#lwSodiumMode .lw-his__unit-btn').forEach(function(x){ x.classList.remove('is-active'); }); smb.classList.add('is-active'); } }
      // Show welcome back
      var wb = $('#lwWelcomeBack'); if(wb) wb.style.display = 'block';
    } catch(e){}
  }

  /* Test hook (v3.21): inert in production — only exposed when the root
     element carries data-test-hook="1", which the live Shopify section never
     sets. Lets automated checks drive the calc engine without a browser. */
  if(root.dataset.testHook === '1'){
    try {
      window.__lwHIS = {
        state: state,
        calculate: calculate,
        buildPayload: buildPayload,
        determinePhases: determinePhases,
        isShortSession: isShortSession,
        renderProtocol: renderProtocol,
        renderInventory: renderInventory,
        renderCalculations: renderCalculations,
        updatePreview: updatePreview,
        renderResults: renderResults,
        buildEmailHtml: buildEmailHtml,
        buildSummary: buildSummary
      };
    } catch(e){}
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();